// routes.js - Configuration for all calculator routes

export const calculatorRoutes = [
  // Payroll Calculators
  {
  path: "/PayrollCalculatorUSA",
  component: "PayrollCalculatorUSA",
  title: "US Payroll Calculator - Calculate Net Salary & Taxes | AfterTaxPay.net",
  description: "Use AfterTaxPay.net's US Payroll Calculator to calculate your net salary, taxes, and deductions. Perfect for employees, freelancers, and businesses in the United States.",
  keywords: "US payroll calculator, salary calculator USA, net salary calculator, tax calculator USA, deductions calculator"
},
{
  path: "/PayrollCalculatorUK",
  component: "PayrollCalculatorUK",
  title: "UK Payroll Calculator - Calculate Net Salary & Taxes | AfterTaxPay.net",
  description: "Use AfterTaxPay.net's UK Payroll Calculator to calculate your net salary, taxes, and deductions. Perfect for employees, freelancers, and businesses in the United Kingdom.",
  keywords: "UK payroll calculator, salary calculator UK, net salary calculator, tax calculator UK, deductions calculator"
},
{
  path: "/PayrollCalculatorCanada",
  component: "PayrollCalculatorCanada",
  title: "Canada Payroll Calculator - Calculate Net Salary & Taxes | AfterTaxPay.net",
  description: "Use AfterTaxPay.net's Canada Payroll Calculator to calculate your net salary, taxes, and deductions. Perfect for employees, freelancers, and businesses in Canada.",
  keywords: "Canada payroll calculator, salary calculator Canada, net salary calculator, tax calculator Canada, deductions calculator"
},
{
  path: "/PayrollCalculatorAustralia",
  component: "PayrollCalculatorAustralia",
  title: "Australia Payroll Calculator - Calculate Net Salary & Taxes | AfterTaxPay.net",
  description: "Use AfterTaxPay.net's Australia Payroll Calculator to calculate your net salary, taxes, and deductions. Perfect for employees, freelancers, and businesses in Australia.",
  keywords: "Australia payroll calculator, salary calculator Australia, net salary calculator, tax calculator Australia, deductions calculator"
},
{
  path: "/PayrollCalculatorFrance",
  component: "PayrollCalculatorFrance",
  title: "France Payroll Calculator - Calculate Net Salary & Taxes | AfterTaxPay.net",
  description: "Use AfterTaxPay.net's France Payroll Calculator to calculate your net salary, taxes, and deductions. Perfect for employees, freelancers, and businesses in France.",
  keywords: "France payroll calculator, salary calculator France, net salary calculator, tax calculator France, deductions calculator"
},
{
  path: "/PayrollCalculatorGermany",
  component: "PayrollCalculatorGermany",
  title: "Germany Payroll Calculator - Calculate Net Salary & Taxes | AfterTaxPay.net",
  description: "Use AfterTaxPay.net's Germany Payroll Calculator to calculate your net salary, taxes, and deductions. Perfect for employees, freelancers, and businesses in Germany.",
  keywords: "Germany payroll calculator, salary calculator Germany, net salary calculator, tax calculator Germany, deductions calculator"
},
{
  path: "/PayrollCalculatorNZ",
  component: "PayrollCalculatorNZ",
  title: "New Zealand Payroll Calculator - Calculate Net Salary & Taxes | AfterTaxPay.net",
  description: "Use AfterTaxPay.net's New Zealand Payroll Calculator to calculate your net salary, taxes, and deductions. Perfect for employees, freelancers, and businesses in New Zealand.",
  keywords: "New Zealand payroll calculator, NZ salary calculator, net salary calculator, tax calculator New Zealand, deductions calculator"
},
{
  path: "/PayrollCalculatorSpain",
  component: "PayrollCalculatorSpain",
  title: "Spain Payroll Calculator - Calculate Net Salary & Taxes | AfterTaxPay.net",
  description: "Use AfterTaxPay.net's Spain Payroll Calculator to calculate your net salary, taxes, and deductions. Perfect for employees, freelancers, and businesses in Spain.",
  keywords: "Spain payroll calculator, salary calculator Spain, net salary calculator, tax calculator Spain, deductions calculator"
},
{
  path: "/PayrollCalculatorNL",
  component: "PayrollCalculatorNL",
  title: "Netherlands Payroll Calculator - Calculate Net Salary & Taxes | AfterTaxPay.net",
  description: "Use AfterTaxPay.net's Netherlands Payroll Calculator to calculate your net salary, taxes, and deductions. Perfect for employees, freelancers, and businesses in the Netherlands.",
  keywords: "Netherlands payroll calculator, Dutch salary calculator, net salary calculator, tax calculator Netherlands, deductions calculator"
},
{
  path: "/PayrollCalculatorJapan",
  component: "PayrollCalculatorJapan",
  title: "Japan Payroll Calculator - Calculate Net Salary & Taxes | AfterTaxPay.net",
  description: "Use AfterTaxPay.net's Japan Payroll Calculator to calculate your net salary, taxes, and deductions. Perfect for employees, freelancers, and businesses in Japan.",
  keywords: "Japan payroll calculator, salary calculator Japan, net salary calculator, tax calculator Japan, deductions calculator"
},
{
  path: "/PayrollCalculatorSweden",
  component: "PayrollCalculatorSweden",
  title: "Sweden Payroll Calculator - Calculate Net Salary & Taxes | AfterTaxPay.net",
  description: "Use AfterTaxPay.net's Sweden Payroll Calculator to calculate your net salary, taxes, and deductions. Perfect for employees, freelancers, and businesses in Sweden.",
  keywords: "Sweden payroll calculator, salary calculator Sweden, net salary calculator, tax calculator Sweden, deductions calculator"
},
{
  path: "/PayrollCalculatorItaly",
  component: "PayrollCalculatorItaly",
  title: "Italy Payroll Calculator - Calculate Net Salary & Taxes | AfterTaxPay.net",
  description: "Use AfterTaxPay.net's Italy Payroll Calculator to calculate your net salary, taxes, and deductions. Perfect for employees, freelancers, and businesses in Italy.",
  keywords: "Italy payroll calculator, salary calculator Italy, net salary calculator, tax calculator Italy, deductions calculator"
},
{
  path: "/PayrollCalculatorAustria",
  component: "PayrollCalculatorAustria",
  title: "Austria Payroll Calculator - Calculate Net Salary & Taxes | AfterTaxPay.net",
  description: "Use AfterTaxPay.net's Austria Payroll Calculator to calculate your net salary, taxes, and deductions. Perfect for employees, freelancers, and businesses in Austria.",
  keywords: "Austria payroll calculator, salary calculator Austria, net salary calculator, tax calculator Austria, deductions calculator"
},
{
  path: "/PayrollCalculatorFinland",
  component: "PayrollCalculatorFinland",
  title: "Finland Payroll Calculator - Calculate Net Salary & Taxes | AfterTaxPay.net",
  description: "Use AfterTaxPay.net's Finland Payroll Calculator to calculate your net salary, taxes, and deductions. Perfect for employees, freelancers, and businesses in Finland.",
  keywords: "Finland payroll calculator, salary calculator Finland, net salary calculator, tax calculator Finland, deductions calculator"
},
{
  path: "/PayrollCalculatorIndia",
  component: "PayrollCalculatorIndia",
  title: "India Payroll Calculator - Calculate Net Salary & Taxes | AfterTaxPay.net",
  description: "Use AfterTaxPay.net's India Payroll Calculator to calculate your net salary, taxes, and deductions. Perfect for employees, freelancers, and businesses in India.",
  keywords: "India payroll calculator, salary calculator India, net salary calculator, tax calculator India, deductions calculator"
},
{
  path: "/PayrollCalculatorDenmark",
  component: "PayrollCalculatorDenmark",
  title: "Denmark Payroll Calculator - Calculate Net Salary & Taxes | AfterTaxPay.net",
  description: "Use AfterTaxPay.net's Denmark Payroll Calculator to calculate your net salary, taxes, and deductions. Perfect for employees, freelancers, and businesses in Denmark.",
  keywords: "Denmark payroll calculator, salary calculator Denmark, net salary calculator, tax calculator Denmark, deductions calculator"
},
{
  path: "/PayrollCalculatorSwitzerland",
  component: "PayrollCalculatorSwitzerland",
  title: "Switzerland Payroll Calculator - Calculate Net Salary & Taxes | AfterTaxPay.net",
  description: "Use AfterTaxPay.net's Switzerland Payroll Calculator to calculate your net salary, taxes, and deductions. Perfect for employees, freelancers, and businesses in Switzerland.",
  keywords: "Switzerland payroll calculator, Swiss salary calculator, net salary calculator, tax calculator Switzerland, deductions calculator"
},
{
  path: "/PayrollCalculatorNorway",
  component: "PayrollCalculatorNorway",
  title: "Norway Payroll Calculator - Calculate Net Salary & Taxes | AfterTaxPay.net",
  description: "Use AfterTaxPay.net's Norway Payroll Calculator to calculate your net salary, taxes, and deductions. Perfect for employees, freelancers, and businesses in Norway.",
  keywords: "Norway payroll calculator, salary calculator Norway, net salary calculator, tax calculator Norway, deductions calculator"
},
{
  path: "/PayrollCalculatorSingapore",
  component: "PayrollCalculatorSingapore",
  title: "Singapore Payroll Calculator - Calculate Net Salary & Taxes | AfterTaxPay.net",
  description: "Use AfterTaxPay.net's Singapore Payroll Calculator to calculate your net salary, taxes, and deductions. Perfect for employees, freelancers, and businesses in Singapore.",
  keywords: "Singapore payroll calculator, salary calculator Singapore, net salary calculator, tax calculator Singapore, deductions calculator"
},
{
  path: "/PayrollCalculatorMexico",
  component: "PayrollCalculatorMexico",
  title: "Mexico Payroll Calculator - Calculate Net Salary & Taxes | AfterTaxPay.net",
  description: "Use AfterTaxPay.net's Mexico Payroll Calculator to calculate your net salary, taxes, and deductions. Perfect for employees, freelancers, and businesses in Mexico.",
  keywords: "Mexico payroll calculator, salary calculator Mexico, net salary calculator, tax calculator Mexico, deductions calculator"
},
{
  path: "/PayrollCalculatorBelgium",
  component: "PayrollCalculatorBelgium",
  title: "Belgium Payroll Calculator - Calculate Net Salary & Taxes | AfterTaxPay.net",
  description: "Use AfterTaxPay.net's Belgium Payroll Calculator to calculate your net salary, taxes, and deductions. Perfect for employees, freelancers, and businesses in Belgium.",
  keywords: "Belgium payroll calculator, salary calculator Belgium, net salary calculator, tax calculator Belgium, deductions calculator"
},
{
  path: "/PayrollCalculatorBrasil",
  component: "PayrollCalculatorBrasil",
  title: "Brazil Payroll Calculator - Calculate Net Salary & Taxes | AfterTaxPay.net",
  description: "Use AfterTaxPay.net's Brazil Payroll Calculator to calculate your net salary, taxes, and deductions. Perfect for employees, freelancers, and businesses in Brazil.",
  keywords: "Brazil payroll calculator, salary calculator Brazil, net salary calculator, tax calculator Brazil, deductions calculator"
},
{
  path: "/PayrollCalculatorEgypt",
  component: "PayrollCalculatorEgypt",
  title: "Egypt Payroll Calculator - Calculate Net Salary & Taxes | AfterTaxPay.net",
  description: "Use AfterTaxPay.net's Egypt Payroll Calculator to calculate your net salary, taxes, and deductions. Perfect for employees, freelancers, and businesses in Egypt.",
  keywords: "Egypt payroll calculator, salary calculator Egypt, net salary calculator, tax calculator Egypt, deductions calculator"
},
{
  path: "/PayrollCalculatorChina",
  component: "PayrollCalculatorChina",
  title: "China Payroll Calculator - Calculate Net Salary & Taxes | AfterTaxPay.net",
  description: "Use AfterTaxPay.net's China Payroll Calculator to calculate your net salary, taxes, and deductions. Perfect for employees, freelancers, and businesses in China.",
  keywords: "China payroll calculator, salary calculator China, net salary calculator, tax calculator China, deductions calculator"
},
{
  path: "/PayrollCalculatorColombia",
  component: "PayrollCalculatorColombia",
  title: "Colombia Payroll Calculator - Calculate Net Salary & Taxes | AfterTaxPay.net",
  description: "Use AfterTaxPay.net's Colombia Payroll Calculator to calculate your net salary, taxes, and deductions. Perfect for employees, freelancers, and businesses in Colombia.",
  keywords: "Colombia payroll calculator, salary calculator Colombia, net salary calculator, tax calculator Colombia, deductions calculator"
},
{
  path: "/PayrollCalculatorHungary",
  component: "PayrollCalculatorHungary",
  title: "Hungary Payroll Calculator - Calculate Net Salary & Taxes | AfterTaxPay.net",
  description: "Use AfterTaxPay.net's Hungary Payroll Calculator to calculate your net salary, taxes, and deductions. Perfect for employees, freelancers, and businesses in Hungary.",
  keywords: "Hungary payroll calculator, salary calculator Hungary, net salary calculator, tax calculator Hungary, deductions calculator"
},
{
  path: "/PayrollCalculatorHongKong",
  component: "PayrollCalculatorHongKong",
  title: "Hong Kong Payroll Calculator - Calculate Net Salary & Taxes | AfterTaxPay.net",
  description: "Use AfterTaxPay.net's Hong Kong Payroll Calculator to calculate your net salary, taxes, and deductions. Perfect for employees, freelancers, and businesses in Hong Kong.",
  keywords: "Hong Kong payroll calculator, salary calculator Hong Kong, net salary calculator, tax calculator Hong Kong, deductions calculator"
},
{
  path: "/PayrollCalculatorIndonesia",
  component: "PayrollCalculatorIndonesia",
  title: "Indonesia Payroll Calculator - Calculate Net Salary & Taxes | AfterTaxPay.net",
  description: "Use AfterTaxPay.net's Indonesia Payroll Calculator to calculate your net salary, taxes, and deductions. Perfect for employees, freelancers, and businesses in Indonesia.",
  keywords: "Indonesia payroll calculator, salary calculator Indonesia, net salary calculator, tax calculator Indonesia, deductions calculator"
},
{
  path: "/PayrollCalculatorMalaysia",
  component: "PayrollCalculatorMalaysia",
  title: "Malaysia Payroll Calculator - Calculate Net Salary & Taxes | AfterTaxPay.net",
  description: "Use AfterTaxPay.net's Malaysia Payroll Calculator to calculate your net salary, taxes, and deductions. Perfect for employees, freelancers, and businesses in Malaysia.",
  keywords: "Malaysia payroll calculator, salary calculator Malaysia, net salary calculator, tax calculator Malaysia, deductions calculator"
},
{
  path: "/PayrollCalculatorPhilippines",
  component: "PayrollCalculatorPhilippines",
  title: "Philippines Payroll Calculator - Calculate Net Salary & Taxes | AfterTaxPay.net",
  description: "Use AfterTaxPay.net's Philippines Payroll Calculator to calculate your net salary, taxes, and deductions. Perfect for employees, freelancers, and businesses in the Philippines.",
  keywords: "Philippines payroll calculator, salary calculator Philippines, net salary calculator, tax calculator Philippines, deductions calculator"
},


  // Income Tax Calculators
  {
  path: "/IncomeTaxCalculatorUSA",
  component: "IncomeTaxCalculatorUSA",
  title: "US Income Tax Calculator - Calculate Federal & State Taxes | AfterTaxPay.net",
  description: "Use AfterTaxPay.net's US Income Tax Calculator to estimate your federal and state income taxes. Perfect for tax planning and financial management in the United States.",
  keywords: "US income tax calculator, federal tax calculator, state tax calculator, tax estimator USA, income tax estimator"
},
{
  path: "/IncomeTaxCalculatorCanada",
  component: "IncomeTaxCalculatorCanada",
  title: "Canada Income Tax Calculator - Calculate Federal & Provincial Taxes | AfterTaxPay.net",
  description: "Use AfterTaxPay.net's Canada Income Tax Calculator to estimate your federal and provincial income taxes. Perfect for tax planning and financial management in Canada.",
  keywords: "Canada income tax calculator, federal tax calculator Canada, provincial tax calculator, tax estimator Canada, income tax estimator"
},
{
  path: "/IncomeTaxCalculatorAustralia",
  component: "IncomeTaxCalculatorAustralia",
  title: "Australia Income Tax Calculator - Calculate Your Tax Return | AfterTaxPay.net",
  description: "Use AfterTaxPay.net's Australia Income Tax Calculator to estimate your income taxes and potential tax return. Perfect for tax planning and financial management in Australia.",
  keywords: "Australia income tax calculator, tax return calculator Australia, ATO tax calculator, tax estimator Australia, income tax estimator"
},
{
  path: "/IncomeTaxCalculatorUK",
  component: "IncomeTaxCalculatorUK",
  title: "UK Income Tax Calculator - Calculate Income Tax & National Insurance | AfterTaxPay.net",
  description: "Use AfterTaxPay.net's UK Income Tax Calculator to estimate your income tax and National Insurance contributions. Perfect for tax planning and financial management in the United Kingdom.",
  keywords: "UK income tax calculator, tax calculator UK, National Insurance calculator, tax estimator UK, income tax estimator"
},
{
  path: "/IncomeTaxCalculatorGermany",
  component: "IncomeTaxCalculatorGermany",
  title: "Germany Income Tax Calculator - Calculate Income Tax & Solidarity Surcharge | AfterTaxPay.net",
  description: "Use AfterTaxPay.net's Germany Income Tax Calculator to estimate your income tax and solidarity surcharge. Perfect for tax planning and financial management in Germany.",
  keywords: "Germany income tax calculator, German tax calculator, solidarity surcharge calculator, tax estimator Germany, income tax estimator"
},
{
  path: "/IncomeTaxCalculatorSwitzerland",
  component: "IncomeTaxCalculatorSwitzerland",
  title: "Switzerland Income Tax Calculator - Calculate Federal & Cantonal Taxes | AfterTaxPay.net",
  description: "Use AfterTaxPay.net's Switzerland Income Tax Calculator to estimate your federal and cantonal income taxes. Perfect for tax planning and financial management in Switzerland.",
  keywords: "Switzerland income tax calculator, Swiss tax calculator, cantonal tax calculator, tax estimator Switzerland, income tax estimator"
},
{
  path: "/IncomeTaxCalculatorNorway",
  component: "IncomeTaxCalculatorNorway",
  title: "Norway Income Tax Calculator - Calculate Taxable Income & Deductions | AfterTaxPay.net",
  description: "Use AfterTaxPay.net's Norway Income Tax Calculator to estimate your taxable income and tax deductions. Perfect for tax planning and financial management in Norway.",
  keywords: "Norway income tax calculator, Norwegian tax calculator, tax deductions Norway, tax estimator Norway, income tax estimator"
},
{
  path: "/IncomeTaxCalculatorNetherlands",
  component: "IncomeTaxCalculatorNetherlands",
  title: "Netherlands Income Tax Calculator - Calculate Box 1, 2, 3 Taxes | AfterTaxPay.net",
  description: "Use AfterTaxPay.net's Netherlands Income Tax Calculator to estimate your box 1, 2, and 3 income taxes. Perfect for tax planning and financial management in the Netherlands.",
  keywords: "Netherlands income tax calculator, Dutch tax calculator, box system tax calculator, tax estimator Netherlands, income tax estimator"
},
{
  path: "/IncomeTaxCalculatorNewZealand",
  component: "IncomeTaxCalculatorNewZealand",
  title: "New Zealand Income Tax Calculator - Calculate NZ Income Tax | AfterTaxPay.net",
  description: "Use AfterTaxPay.net's New Zealand Income Tax Calculator to estimate your income taxes. Perfect for tax planning and financial management in New Zealand.",
  keywords: "New Zealand income tax calculator, NZ tax calculator, IRD tax calculator, tax estimator New Zealand, income tax estimator"
},
{
  path: "/IncomeTaxCalculatorSweden",
  component: "IncomeTaxCalculatorSweden",
  title: "Sweden Income Tax Calculator - Calculate Municipal & State Taxes | AfterTaxPay.net",
  description: "Use AfterTaxPay.net's Sweden Income Tax Calculator to estimate your municipal and state income taxes. Perfect for tax planning and financial management in Sweden.",
  keywords: "Sweden income tax calculator, Swedish tax calculator, municipal tax calculator, tax estimator Sweden, income tax estimator"
},
{
  path: "/IncomeTaxCalculatorFrance",
  component: "IncomeTaxCalculatorFrance",
  title: "France Income Tax Calculator - Calculate French Income Tax | AfterTaxPay.net",
  description: "Use AfterTaxPay.net's France Income Tax Calculator to estimate your French income taxes. Perfect for tax planning and financial management in France.",
  keywords: "France income tax calculator, French tax calculator, impôt sur le revenu calculator, tax estimator France, income tax estimator"
},
{
  path: "/IncomeTaxCalculatorItaly",
  component: "IncomeTaxCalculatorItaly",
  title: "Italy Income Tax Calculator - Calculate IRPEF & Regional Taxes | AfterTaxPay.net",
  description: "Use AfterTaxPay.net's Italy Income Tax Calculator to estimate your IRPEF and regional income taxes. Perfect for tax planning and financial management in Italy.",
  keywords: "Italy income tax calculator, Italian tax calculator, IRPEF calculator, tax estimator Italy, income tax estimator"
},
{
  path: "/IncomeTaxCalculatorSpain",
  component: "IncomeTaxCalculatorSpain",
  title: "Spain Income Tax Calculator - Calculate IRPF & Autonomous Taxes | AfterTaxPay.net",
  description: "Use AfterTaxPay.net's Spain Income Tax Calculator to estimate your IRPF and autonomous community taxes. Perfect for tax planning and financial management in Spain.",
  keywords: "Spain income tax calculator, Spanish tax calculator, IRPF calculator, tax estimator Spain, income tax estimator"
},
{
  path: "/IncomeTaxCalculatorIndia",
  component: "IncomeTaxCalculatorIndia",
  title: "India Income Tax Calculator - Calculate Income Tax & TDS | AfterTaxPay.net",
  description: "Use AfterTaxPay.net's India Income Tax Calculator to estimate your income tax and TDS. Perfect for tax planning and financial management in India.",
  keywords: "India income tax calculator, Indian tax calculator, TDS calculator, tax estimator India, income tax estimator"
},
{
  path: "/IncomeTaxCalculatorJapan",
  component: "IncomeTaxCalculatorJapan",
  title: "Japan Income Tax Calculator - Calculate Income Tax & Resident Tax | AfterTaxPay.net",
  description: "Use AfterTaxPay.net's Japan Income Tax Calculator to estimate your national income tax and resident tax. Perfect for tax planning and financial management in Japan.",
  keywords: "Japan income tax calculator, Japanese tax calculator, resident tax calculator, tax estimator Japan, income tax estimator"
},
{
  path: "/IncomeTaxCalculatorDenmark",
  component: "IncomeTaxCalculatorDenmark",
  title: "Denmark Income Tax Calculator - Calculate Income Tax & Labor Market Tax | AfterTaxPay.net",
  description: "Use AfterTaxPay.net's Denmark Income Tax Calculator to estimate your income tax and labor market contributions. Perfect for tax planning and financial management in Denmark.",
  keywords: "Denmark income tax calculator, Danish tax calculator, labor market tax calculator, tax estimator Denmark, income tax estimator"
},
{
  path: "/IncomeTaxCalculatorFinland",
  component: "IncomeTaxCalculatorFinland",
  title: "Finland Income Tax Calculator - Calculate Municipal & State Taxes | AfterTaxPay.net",
  description: "Use AfterTaxPay.net's Finland Income Tax Calculator to estimate your municipal and state income taxes. Perfect for tax planning and financial management in Finland.",
  keywords: "Finland income tax calculator, Finnish tax calculator, municipal tax Finland, tax estimator Finland, income tax estimator"
},
{
  path: "/IncomeTaxCalculatorAustria",
  component: "IncomeTaxCalculatorAustria",
  title: "Austria Income Tax Calculator - Calculate Income Tax & Church Tax | AfterTaxPay.net",
  description: "Use AfterTaxPay.net's Austria Income Tax Calculator to estimate your income tax and church tax. Perfect for tax planning and financial management in Austria.",
  keywords: "Austria income tax calculator, Austrian tax calculator, church tax calculator, tax estimator Austria, income tax estimator"
},
{
  path: "/IncomeTaxCalculatorSingapore",
  component: "IncomeTaxCalculatorSingapore",
  title: "Singapore Income Tax Calculator - Calculate IRAS Income Tax | AfterTaxPay.net",
  description: "Use AfterTaxPay.net's Singapore Income Tax Calculator to estimate your IRAS income taxes. Perfect for tax planning and financial management in Singapore.",
  keywords: "Singapore income tax calculator, Singapore tax calculator, IRAS tax calculator, tax estimator Singapore, income tax estimator"
},
{
  path: "/IncomeTaxCalculatorMexico",
  component: "IncomeTaxCalculatorMexico",
  title: "Mexico Income Tax Calculator - Calculate ISR Tax | AfterTaxPay.net",
  description: "Use AfterTaxPay.net's Mexico Income Tax Calculator to estimate your ISR (Impuesto Sobre la Renta) taxes. Perfect for tax planning and financial management in Mexico.",
  keywords: "Mexico income tax calculator, Mexican tax calculator, ISR calculator, tax estimator Mexico, income tax estimator"
},
{
  path: "/IncomeTaxCalculatorBelgium",
  component: "IncomeTaxCalculatorBelgium",
  title: "Belgium Income Tax Calculator - Calculate Personal Income Tax | AfterTaxPay.net",
  description: "Use AfterTaxPay.net's Belgium Income Tax Calculator to estimate your personal income taxes. Perfect for tax planning and financial management in Belgium.",
  keywords: "Belgium income tax calculator, Belgian tax calculator, personal income tax Belgium, tax estimator Belgium, income tax estimator"
},
{
  path: "/IncomeTaxCalculatorBrasil",
  component: "IncomeTaxCalculatorBrasil",
  title: "Brazil Income Tax Calculator - Calculate IRPF Tax | AfterTaxPay.net",
  description: "Use AfterTaxPay.net's Brazil Income Tax Calculator to estimate your IRPF (Imposto de Renda) taxes. Perfect for tax planning and financial management in Brazil.",
  keywords: "Brazil income tax calculator, Brazilian tax calculator, IRPF calculator, tax estimator Brazil, income tax estimator"
},
{
  path: "/IncomeTaxCalculatorEgypt",
  component: "IncomeTaxCalculatorEgypt",
  title: "Egypt Income Tax Calculator - Calculate Income Tax & Deductions | AfterTaxPay.net",
  description: "Use AfterTaxPay.net's Egypt Income Tax Calculator to estimate your income taxes and deductions. Perfect for tax planning and financial management in Egypt.",
  keywords: "Egypt income tax calculator, Egyptian tax calculator, tax deductions Egypt, tax estimator Egypt, income tax estimator"
},
{
  path: "/IncomeTaxCalculatorChina",
  component: "IncomeTaxCalculatorChina",
  title: "China Income Tax Calculator - Calculate Individual Income Tax | AfterTaxPay.net",
  description: "Use AfterTaxPay.net's China Income Tax Calculator to estimate your individual income taxes. Perfect for tax planning and financial management in China.",
  keywords: "China income tax calculator, Chinese tax calculator, individual income tax China, tax estimator China, income tax estimator"
},
{
  path: "/IncomeTaxCalculatorColombia",
  component: "IncomeTaxCalculatorColombia",
  title: "Colombia Income Tax Calculator - Calculate Income Tax & ICA | AfterTaxPay.net",
  description: "Use AfterTaxPay.net's Colombia Income Tax Calculator to estimate your income taxes and ICA. Perfect for tax planning and financial management in Colombia.",
  keywords: "Colombia income tax calculator, Colombian tax calculator, ICA tax calculator, tax estimator Colombia, income tax estimator"
},
{
  path: "/IncomeTaxCalculatorHungary",
  component: "IncomeTaxCalculatorHungary",
  title: "Hungary Income Tax Calculator - Calculate Personal Income Tax | AfterTaxPay.net",
  description: "Use AfterTaxPay.net's Hungary Income Tax Calculator to estimate your personal income taxes. Perfect for tax planning and financial management in Hungary.",
  keywords: "Hungary income tax calculator, Hungarian tax calculator, personal income tax Hungary, tax estimator Hungary, income tax estimator"
},
{
  path: "/IncomeTaxCalculatorHongKong",
  component: "IncomeTaxCalculatorHongKong",
  title: "Hong Kong Income Tax Calculator - Calculate Salaries Tax & MPF | AfterTaxPay.net",
  description: "Use AfterTaxPay.net's Hong Kong Income Tax Calculator to estimate your salaries tax and MPF contributions. Perfect for tax planning and financial management in Hong Kong.",
  keywords: "Hong Kong income tax calculator, HK tax calculator, salaries tax calculator, MPF calculator, tax estimator Hong Kong"
},
{
  path: "/IncomeTaxCalculatorIndonesia",
  component: "IncomeTaxCalculatorIndonesia",
  title: "Indonesia Income Tax Calculator - Calculate PPh 21 Tax | AfterTaxPay.net",
  description: "Use AfterTaxPay.net's Indonesia Income Tax Calculator to estimate your PPh 21 income taxes. Perfect for tax planning and financial management in Indonesia.",
  keywords: "Indonesia income tax calculator, Indonesian tax calculator, PPh 21 calculator, tax estimator Indonesia, income tax estimator"
},
{
  path: "/IncomeTaxCalculatorMalaysia",
  component: "IncomeTaxCalculatorMalaysia",
  title: "Malaysia Income Tax Calculator - Calculate PCB & Income Tax | AfterTaxPay.net",
  description: "Use AfterTaxPay.net's Malaysia Income Tax Calculator to estimate your PCB and income taxes. Perfect for tax planning and financial management in Malaysia.",
  keywords: "Malaysia income tax calculator, Malaysian tax calculator, PCB calculator, tax estimator Malaysia, income tax estimator"
},
{
  path: "/IncomeTaxCalculatorPhilippines",
  component: "IncomeTaxCalculatorPhilippines",
  title: "Philippines Income Tax Calculator - Calculate Withholding Tax & Income Tax | AfterTaxPay.net",
  description: "Use AfterTaxPay.net's Philippines Income Tax Calculator to estimate your withholding tax and income taxes. Perfect for tax planning and financial management in the Philippines.",
  keywords: "Philippines income tax calculator, Philippine tax calculator, withholding tax calculator, tax estimator Philippines, income tax estimator"
},


  // Tax Reports
  {
  path: "/TaxReportsUSA",
  component: "TaxReportsUSA",
  title: "US Tax Reports - Generate Tax Forms & Documents | AfterTaxPay.net",
  description: "Generate comprehensive US tax reports, forms, and documents with AfterTaxPay.net. Create W-2, 1099, tax summaries, and financial reports for the United States.",
  keywords: "US tax reports, tax forms USA, W-2 generator, 1099 forms, tax documents USA, financial reports"
},
{
  path: "/TaxReportsCanada",
  component: "TaxReportsCanada",
  title: "Canada Tax Reports - Generate T4, T4A & Tax Documents | AfterTaxPay.net",
  description: "Generate comprehensive Canada tax reports, forms, and documents with AfterTaxPay.net. Create T4, T4A, tax summaries, and financial reports for Canada.",
  keywords: "Canada tax reports, tax forms Canada, T4 generator, T4A forms, tax documents Canada, financial reports"
},
{
  path: "/TaxReportsAustralia",
  component: "TaxReportsAustralia",
  title: "Australia Tax Reports - Generate PAYG & Tax Documents | AfterTaxPay.net",
  description: "Generate comprehensive Australia tax reports, forms, and documents with AfterTaxPay.net. Create PAYG summaries, tax statements, and financial reports for Australia.",
  keywords: "Australia tax reports, tax forms Australia, PAYG generator, tax statements, tax documents Australia, financial reports"
},
{
  path: "/TaxReportsUK",
  component: "TaxReportsUK",
  title: "UK Tax Reports - Generate P45, P60 & Tax Documents | AfterTaxPay.net",
  description: "Generate comprehensive UK tax reports, forms, and documents with AfterTaxPay.net. Create P45, P60, tax summaries, and financial reports for the United Kingdom.",
  keywords: "UK tax reports, tax forms UK, P45 generator, P60 forms, tax documents UK, financial reports"
},
{
  path: "/TaxReportsGermany",
  component: "TaxReportsGermany",
  title: "Germany Tax Reports - Generate Lohnsteuer & Tax Documents | AfterTaxPay.net",
  description: "Generate comprehensive Germany tax reports, forms, and documents with AfterTaxPay.net. Create Lohnsteuer certificates, tax summaries, and financial reports for Germany.",
  keywords: "Germany tax reports, tax forms Germany, Lohnsteuer generator, tax certificates, tax documents Germany, financial reports"
},
{
  path: "/TaxReportsSwitzerland",
  component: "TaxReportsSwitzerland",
  title: "Switzerland Tax Reports - Generate Tax Certificates & Documents | AfterTaxPay.net",
  description: "Generate comprehensive Switzerland tax reports, forms, and documents with AfterTaxPay.net. Create tax certificates, annual statements, and financial reports for Switzerland.",
  keywords: "Switzerland tax reports, tax forms Switzerland, tax certificates, annual statements, tax documents Switzerland, financial reports"
},
{
  path: "/TaxReportsNorway",
  component: "TaxReportsNorway",
  title: "Norway Tax Reports - Generate Tax Cards & Documents | AfterTaxPay.net",
  description: "Generate comprehensive Norway tax reports, forms, and documents with AfterTaxPay.net. Create tax cards, annual statements, and financial reports for Norway.",
  keywords: "Norway tax reports, tax forms Norway, tax card generator, annual statements, tax documents Norway, financial reports"
},
{
  path: "/TaxReportsNetherlands",
  component: "TaxReportsNetherlands",
  title: "Netherlands Tax Reports - Generate Jaaropgave & Documents | AfterTaxPay.net",
  description: "Generate comprehensive Netherlands tax reports, forms, and documents with AfterTaxPay.net. Create jaaropgave, annual statements, and financial reports for the Netherlands.",
  keywords: "Netherlands tax reports, tax forms Netherlands, jaaropgave generator, annual statements, tax documents Netherlands, financial reports"
},
{
  path: "/TaxReportsNewZealand",
  component: "TaxReportsNewZealand",
  title: "New Zealand Tax Reports - Generate IRD Forms & Documents | AfterTaxPay.net",
  description: "Generate comprehensive New Zealand tax reports, forms, and documents with AfterTaxPay.net. Create IRD forms, tax summaries, and financial reports for New Zealand.",
  keywords: "New Zealand tax reports, tax forms NZ, IRD forms generator, tax summaries, tax documents New Zealand, financial reports"
},
{
  path: "/TaxReportsSweden",
  component: "TaxReportsSweden",
  title: "Sweden Tax Reports - Generate Inkomstdeklaration & Documents | AfterTaxPay.net",
  description: "Generate comprehensive Sweden tax reports, forms, and documents with AfterTaxPay.net. Create inkomstdeklaration, tax summaries, and financial reports for Sweden.",
  keywords: "Sweden tax reports, tax forms Sweden, inkomstdeklaration generator, tax summaries, tax documents Sweden, financial reports"
},
{
  path: "/TaxReportsFrance",
  component: "TaxReportsFrance",
  title: "France Tax Reports - Generate Fiche de Paie & Documents | AfterTaxPay.net",
  description: "Generate comprehensive France tax reports, forms, and documents with AfterTaxPay.net. Create fiche de paie, tax summaries, and financial reports for France.",
  keywords: "France tax reports, tax forms France, fiche de paie generator, pay slips, tax documents France, financial reports"
},
{
  path: "/TaxReportsItaly",
  component: "TaxReportsItaly",
  title: "Italy Tax Reports - Generate CU & Tax Documents | AfterTaxPay.net",
  description: "Generate comprehensive Italy tax reports, forms, and documents with AfterTaxPay.net. Create CU certificates, tax summaries, and financial reports for Italy.",
  keywords: "Italy tax reports, tax forms Italy, CU certificate generator, tax summaries, tax documents Italy, financial reports"
},
{
  path: "/TaxReportsSpain",
  component: "TaxReportsSpain",
  title: "Spain Tax Reports - Generate Nomina & Tax Documents | AfterTaxPay.net",
  description: "Generate comprehensive Spain tax reports, forms, and documents with AfterTaxPay.net. Create nomina slips, tax summaries, and financial reports for Spain.",
  keywords: "Spain tax reports, tax forms Spain, nomina generator, pay slips, tax documents Spain, financial reports"
},
{
  path: "/TaxReportsIndia",
  component: "TaxReportsIndia",
  title: "India Tax Reports - Generate Form 16 & Tax Documents | AfterTaxPay.net",
  description: "Generate comprehensive India tax reports, forms, and documents with AfterTaxPay.net. Create Form 16, tax summaries, and financial reports for India.",
  keywords: "India tax reports, tax forms India, Form 16 generator, tax certificates, tax documents India, financial reports"
},
{
  path: "/TaxReportsJapan",
  component: "TaxReportsJapan",
  title: "Japan Tax Reports - Generate Gensen Chōshuhyo & Documents | AfterTaxPay.net",
  description: "Generate comprehensive Japan tax reports, forms, and documents with AfterTaxPay.net. Create Gensen Chōshuhyo, tax summaries, and financial reports for Japan.",
  keywords: "Japan tax reports, tax forms Japan, Gensen Chōshuhyo generator, withholding slips, tax documents Japan, financial reports"
},
{
  path: "/TaxReportsDenmark",
  component: "TaxReportsDenmark",
  title: "Denmark Tax Reports - Generate Årsopgørelse & Documents | AfterTaxPay.net",
  description: "Generate comprehensive Denmark tax reports, forms, and documents with AfterTaxPay.net. Create årsopgørelse, tax summaries, and financial reports for Denmark.",
  keywords: "Denmark tax reports, tax forms Denmark, årsopgørelse generator, annual statements, tax documents Denmark, financial reports"
},
{
  path: "/TaxReportsFinland",
  component: "TaxReportsFinland",
  title: "Finland Tax Reports - Generate Verokortti & Documents | AfterTaxPay.net",
  description: "Generate comprehensive Finland tax reports, forms, and documents with AfterTaxPay.net. Create verokortti, tax summaries, and financial reports for Finland.",
  keywords: "Finland tax reports, tax forms Finland, verokortti generator, tax cards, tax documents Finland, financial reports"
},
{
  path: "/TaxReportsAustria",
  component: "TaxReportsAustria",
  title: "Austria Tax Reports - Generate Lohnzettel & Documents | AfterTaxPay.net",
  description: "Generate comprehensive Austria tax reports, forms, and documents with AfterTaxPay.net. Create lohnzettel, tax summaries, and financial reports for Austria.",
  keywords: "Austria tax reports, tax forms Austria, lohnzettel generator, pay slips, tax documents Austria, financial reports"
},
{
  path: "/TaxReportsSingapore",
  component: "TaxReportsSingapore",
  title: "Singapore Tax Reports - Generate IR8A & Tax Documents | AfterTaxPay.net",
  description: "Generate comprehensive Singapore tax reports, forms, and documents with AfterTaxPay.net. Create IR8A forms, tax summaries, and financial reports for Singapore.",
  keywords: "Singapore tax reports, tax forms Singapore, IR8A generator, tax certificates, tax documents Singapore, financial reports"
},
{
  path: "/TaxReportsMexico",
  component: "TaxReportsMexico",
  title: "Mexico Tax Reports - Generate Recibo de Nómina & Documents | AfterTaxPay.net",
  description: "Generate comprehensive Mexico tax reports, forms, and documents with AfterTaxPay.net. Create recibo de nómina, tax summaries, and financial reports for Mexico.",
  keywords: "Mexico tax reports, tax forms Mexico, recibo de nómina generator, pay slips, tax documents Mexico, financial reports"
},
{
  path: "/TaxReportsBelgium",
  component: "TaxReportsBelgium",
  title: "Belgium Tax Reports - Generate Fiche de Salaire & Documents | AfterTaxPay.net",
  description: "Generate comprehensive Belgium tax reports, forms, and documents with AfterTaxPay.net. Create fiche de salaire, tax summaries, and financial reports for Belgium.",
  keywords: "Belgium tax reports, tax forms Belgium, fiche de salaire generator, pay slips, tax documents Belgium, financial reports"
},
{
  path: "/TaxReportsBrasil",
  component: "TaxReportsBrasil",
  title: "Brazil Tax Reports - Generate Holerite & Documents | AfterTaxPay.net",
  description: "Generate comprehensive Brazil tax reports, forms, and documents with AfterTaxPay.net. Create holerite, tax summaries, and financial reports for Brazil.",
  keywords: "Brazil tax reports, tax forms Brazil, holerite generator, pay slips, tax documents Brazil, financial reports"
},
{
  path: "/TaxReportsEgypt",
  component: "TaxReportsEgypt",
  title: "Egypt Tax Reports - Generate Tax Certificates & Documents | AfterTaxPay.net",
  description: "Generate comprehensive Egypt tax reports, forms, and documents with AfterTaxPay.net. Create tax certificates, salary statements, and financial reports for Egypt.",
  keywords: "Egypt tax reports, tax forms Egypt, tax certificates, salary statements, tax documents Egypt, financial reports"
},
{
  path: "/TaxReportsChina",
  component: "TaxReportsChina",
  title: "China Tax Reports - Generate Tax Payment Certificates & Documents | AfterTaxPay.net",
  description: "Generate comprehensive China tax reports, forms, and documents with AfterTaxPay.net. Create tax payment certificates, income statements, and financial reports for China.",
  keywords: "China tax reports, tax forms China, tax certificates, income statements, tax documents China, financial reports"
},
{
  path: "/TaxReportsColombia",
  component: "TaxReportsColombia",
  title: "Colombia Tax Reports - Generate Liquidación de Nómina & Documents | AfterTaxPay.net",
  description: "Generate comprehensive Colombia tax reports, forms, and documents with AfterTaxPay.net. Create liquidación de nómina, tax summaries, and financial reports for Colombia.",
  keywords: "Colombia tax reports, tax forms Colombia, liquidación de nómina, pay statements, tax documents Colombia, financial reports"
},
{
  path: "/TaxReportsHungary",
  component: "TaxReportsHungary",
  title: "Hungary Tax Reports - Generate Bérjegyzék & Documents | AfterTaxPay.net",
  description: "Generate comprehensive Hungary tax reports, forms, and documents with AfterTaxPay.net. Create bérjegyzék, tax summaries, and financial reports for Hungary.",
  keywords: "Hungary tax reports, tax forms Hungary, bérjegyzék generator, pay slips, tax documents Hungary, financial reports"
},
{
  path: "/TaxReportsHongKong",
  component: "TaxReportsHongKong",
  title: "Hong Kong Tax Reports - Generate IR56 Forms & Documents | AfterTaxPay.net",
  description: "Generate comprehensive Hong Kong tax reports, forms, and documents with AfterTaxPay.net. Create IR56 forms, tax summaries, and financial reports for Hong Kong.",
  keywords: "Hong Kong tax reports, tax forms Hong Kong, IR56 generator, tax returns, tax documents Hong Kong, financial reports"
},
{
  path: "/TaxReportsIndonesia",
  component: "TaxReportsIndonesia",
  title: "Indonesia Tax Reports - Generate Bukti Potong & Documents | AfterTaxPay.net",
  description: "Generate comprehensive Indonesia tax reports, forms, and documents with AfterTaxPay.net. Create bukti potong, tax summaries, and financial reports for Indonesia.",
  keywords: "Indonesia tax reports, tax forms Indonesia, bukti potong generator, tax certificates, tax documents Indonesia, financial reports"
},
{
  path: "/TaxReportsMalaysia",
  component: "TaxReportsMalaysia",
  title: "Malaysia Tax Reports - Generate EA Forms & Documents | AfterTaxPay.net",
  description: "Generate comprehensive Malaysia tax reports, forms, and documents with AfterTaxPay.net. Create EA forms, tax summaries, and financial reports for Malaysia.",
  keywords: "Malaysia tax reports, tax forms Malaysia, EA form generator, tax certificates, tax documents Malaysia, financial reports"
},
{
  path: "/TaxReportsPhilippines",
  component: "TaxReportsPhilippines",
  title: "Philippines Tax Reports - Generate BIR Forms & Documents | AfterTaxPay.net",
  description: "Generate comprehensive Philippines tax reports, forms, and documents with AfterTaxPay.net. Create BIR forms, tax summaries, and financial reports for the Philippines.",
  keywords: "Philippines tax reports, tax forms Philippines, BIR forms generator, tax certificates, tax documents Philippines, financial reports"
},


  // Property Tax Calculators
 {
  path: "/PropertyTaxCalculatorUSA",
  component: "PropertyTaxCalculatorUSA",
  title: "US Property Tax Calculator - Calculate Real Estate Taxes | AfterTaxPay.net",
  description: "Use AfterTaxPay.net's US Property Tax Calculator to estimate your real estate taxes, millage rates, and property tax liabilities across states and counties.",
  keywords: "US property tax calculator, real estate tax calculator, property tax estimator, millage rate calculator, home tax calculator"
},
{
  path: "/PropertyTaxCalculatorCanada",
  component: "PropertyTaxCalculatorCanada",
  title: "Canada Property Tax Calculator - Calculate Municipal Taxes | AfterTaxPay.net",
  description: "Use AfterTaxPay.net's Canada Property Tax Calculator to estimate your municipal property taxes, assessment values, and tax rates across provinces and cities.",
  keywords: "Canada property tax calculator, municipal tax calculator, property assessment calculator, real estate tax Canada, home tax calculator"
},
{
  path: "/PropertyTaxCalculatorAustralia",
  component: "PropertyTaxCalculatorAustralia",
  title: "Australia Property Tax Calculator - Calculate Land Tax & Council Rates | AfterTaxPay.net",
  description: "Use AfterTaxPay.net's Australia Property Tax Calculator to estimate land tax, council rates, and stamp duty for properties across Australian states and territories.",
  keywords: "Australia property tax calculator, land tax calculator, council rates calculator, stamp duty calculator, real estate tax Australia"
},
{
  path: "/PropertyTaxCalculatorUK",
  component: "PropertyTaxCalculatorUK",
  title: "UK Property Tax Calculator - Calculate Council Tax & Stamp Duty | AfterTaxPay.net",
  description: "Use AfterTaxPay.net's UK Property Tax Calculator to estimate council tax bands, stamp duty land tax, and property taxes across England, Scotland, Wales, and Northern Ireland.",
  keywords: "UK property tax calculator, council tax calculator, stamp duty calculator, SDLT calculator, UK real estate tax"
},
{
  path: "/PropertyTaxCalculatorGerman",
  component: "PropertyTaxCalculatorGerman",
  title: "Germany Property Tax Calculator - Calculate Grundsteuer & Real Estate Tax | AfterTaxPay.net",
  description: "Use AfterTaxPay.net's Germany Property Tax Calculator to estimate Grundsteuer, property transfer tax, and real estate taxes across German states and municipalities.",
  keywords: "Germany property tax calculator, Grundsteuer calculator, real estate tax Germany, property transfer tax, German property tax"
},
{
  path: "/PropertyTaxCalculatorSwitzerland",
  component: "PropertyTaxCalculatorSwitzerland",
  title: "Switzerland Property Tax Calculator - Calculate Property & Wealth Taxes | AfterTaxPay.net",
  description: "Use AfterTaxPay.net's Switzerland Property Tax Calculator to estimate property taxes, wealth taxes, and real estate charges across Swiss cantons and communes.",
  keywords: "Switzerland property tax calculator, Swiss real estate tax, property wealth tax, cantonal property tax, Swiss property calculator"
},
{
  path: "/PropertyTaxCalculatorNorway",
  component: "PropertyTaxCalculatorNorway",
  title: "Norway Property Tax Calculator - Calculate Eiendomsskatt & Property Taxes | AfterTaxPay.net",
  description: "Use AfterTaxPay.net's Norway Property Tax Calculator to estimate eiendomsskatt, property value tax, and municipal property charges across Norwegian municipalities.",
  keywords: "Norway property tax calculator, eiendomsskatt calculator, Norwegian property tax, municipal property tax, real estate tax Norway"
},
{
  path: "/PropertyTaxCalculatorNL",
  component: "PropertyTaxCalculatorNL",
  title: "Netherlands Property Tax Calculator - Calculate Onroerendezaakbelasting | AfterTaxPay.net",
  description: "Use AfterTaxPay.net's Netherlands Property Tax Calculator to estimate onroerendezaakbelasting (OZB), property taxes, and municipal charges across Dutch municipalities.",
  keywords: "Netherlands property tax calculator, OZB calculator, Dutch property tax, onroerendezaakbelasting, real estate tax Netherlands"
},
{
  path: "/PropertyTaxCalculatorNZ",
  component: "PropertyTaxCalculatorNZ",
  title: "New Zealand Property Tax Calculator - Calculate Rates & Land Taxes | AfterTaxPay.net",
  description: "Use AfterTaxPay.net's New Zealand Property Tax Calculator to estimate council rates, land taxes, and property charges across NZ cities and regions.",
  keywords: "New Zealand property tax calculator, council rates calculator, NZ land tax, property rates calculator, real estate tax New Zealand"
},
{
  path: "/PropertyTaxCalculatorSweden",
  component: "PropertyTaxCalculatorSweden",
  title: "Sweden Property Tax Calculator - Calculate Fastighetskatt & Property Taxes | AfterTaxPay.net",
  description: "Use AfterTaxPay.net's Sweden Property Tax Calculator to estimate fastighetskatt, property taxes, and municipal charges across Swedish municipalities.",
  keywords: "Sweden property tax calculator, fastighetskatt calculator, Swedish property tax, municipal property tax, real estate tax Sweden"
},
{
  path: "/PropertyTaxCalculatorFrance",
  component: "PropertyTaxCalculatorFrance",
  title: "France Property Tax Calculator - Calculate Taxe Foncière & Taxe d'Habitation | AfterTaxPay.net",
  description: "Use AfterTaxPay.net's France Property Tax Calculator to estimate taxe foncière, taxe d'habitation, and property taxes across French departments and communes.",
  keywords: "France property tax calculator, taxe foncière calculator, taxe d'habitation calculator, French property tax, real estate tax France"
},
{
  path: "/PropertyTaxCalculatorItaly",
  component: "PropertyTaxCalculatorItaly",
  title: "Italy Property Tax Calculator - Calculate IMU & TASI Taxes | AfterTaxPay.net",
  description: "Use AfterTaxPay.net's Italy Property Tax Calculator to estimate IMU, TASI, and property taxes across Italian regions and municipalities.",
  keywords: "Italy property tax calculator, IMU calculator, TASI calculator, Italian property tax, real estate tax Italy"
},
{
  path: "/PropertyTaxCalculatorSpain",
  component: "PropertyTaxCalculatorSpain",
  title: "Spain Property Tax Calculator - Calculate IBI & Property Taxes | AfterTaxPay.net",
  description: "Use AfterTaxPay.net's Spain Property Tax Calculator to estimate IBI (Impuesto sobre Bienes Inmuebles), property taxes, and municipal charges across Spanish regions.",
  keywords: "Spain property tax calculator, IBI calculator, Spanish property tax, Impuesto sobre Bienes Inmuebles, real estate tax Spain"
},
{
  path: "/PropertyTaxCalculatorIndia",
  component: "PropertyTaxCalculatorIndia",
  title: "India Property Tax Calculator - Calculate Municipal Property Taxes | AfterTaxPay.net",
  description: "Use AfterTaxPay.net's India Property Tax Calculator to estimate municipal property taxes, circle rates, and stamp duty across Indian states and cities.",
  keywords: "India property tax calculator, municipal property tax India, stamp duty calculator, circle rate calculator, real estate tax India"
},
{
  path: "/PropertyTaxCalculatorJapan",
  component: "PropertyTaxCalculatorJapan",
  title: "Japan Property Tax Calculator - Calculate Fixed Asset Tax & City Planning Tax | AfterTaxPay.net",
  description: "Use AfterTaxPay.net's Japan Property Tax Calculator to estimate fixed asset tax, city planning tax, and property taxes across Japanese prefectures and municipalities.",
  keywords: "Japan property tax calculator, fixed asset tax Japan, city planning tax, Japanese property tax, real estate tax Japan"
},
{
  path: "/PropertyTaxCalculatorDenmark",
  component: "PropertyTaxCalculatorDenmark",
  title: "Denmark Property Tax Calculator - Calculate Ejendomsværdiskat & Property Taxes | AfterTaxPay.net",
  description: "Use AfterTaxPay.net's Denmark Property Tax Calculator to estimate ejendomsværdiskat, property taxes, and municipal charges across Danish municipalities.",
  keywords: "Denmark property tax calculator, ejendomsværdiskat calculator, Danish property tax, municipal property tax, real estate tax Denmark"
},
{
  path: "/PropertyTaxCalculatorFinland",
  component: "PropertyTaxCalculatorFinland",
  title: "Finland Property Tax Calculator - Calculate Kiinteistövero & Property Taxes | AfterTaxPay.net",
  description: "Use AfterTaxPay.net's Finland Property Tax Calculator to estimate kiinteistövero, property taxes, and municipal charges across Finnish municipalities.",
  keywords: "Finland property tax calculator, kiinteistövero calculator, Finnish property tax, municipal property tax, real estate tax Finland"
},
{
  path: "/PropertyTaxCalculatorAustria",
  component: "PropertyTaxCalculatorAustria",
  title: "Austria Property Tax Calculator - Calculate Grundsteuer & Real Estate Taxes | AfterTaxPay.net",
  description: "Use AfterTaxPay.net's Austria Property Tax Calculator to estimate Grundsteuer, property taxes, and municipal charges across Austrian states and municipalities.",
  keywords: "Austria property tax calculator, Grundsteuer Austria, Austrian property tax, real estate tax Austria, property tax calculator Austria"
},
{
  path: "/PropertyTaxCalculatorSingapore",
  component: "PropertyTaxCalculatorSingapore",
  title: "Singapore Property Tax Calculator - Calculate Annual Value Tax & ABSD | AfterTaxPay.net",
  description: "Use AfterTaxPay.net's Singapore Property Tax Calculator to estimate property tax based on annual value, Additional Buyer's Stamp Duty, and other property charges.",
  keywords: "Singapore property tax calculator, annual value tax, ABSD calculator, Singapore real estate tax, property tax Singapore"
},
{
  path: "/PropertyTaxCalculatorMexico",
  component: "PropertyTaxCalculatorMexico",
  title: "Mexico Property Tax Calculator - Calculate Predial & Real Estate Taxes | AfterTaxPay.net",
  description: "Use AfterTaxPay.net's Mexico Property Tax Calculator to estimate predial tax, property acquisition tax, and real estate charges across Mexican states and municipalities.",
  keywords: "Mexico property tax calculator, predial tax calculator, Mexican property tax, real estate tax Mexico, property acquisition tax"
},
{
  path: "/PropertyTaxCalculatorBelgium",
  component: "PropertyTaxCalculatorBelgium",
  title: "Belgium Property Tax Calculator - Calculate Onroerende Voorheffing & Property Taxes | AfterTaxPay.net",
  description: "Use AfterTaxPay.net's Belgium Property Tax Calculator to estimate onroerende voorheffing, property registration tax, and real estate charges across Belgian regions.",
  keywords: "Belgium property tax calculator, onroerende voorheffing, Belgian property tax, registration tax, real estate tax Belgium"
},
{
  path: "/PropertyTaxCalculatorBrasil",
  component: "PropertyTaxCalculatorBrasil",
  title: "Brazil Property Tax Calculator - Calculate IPTU & ITBI Taxes | AfterTaxPay.net",
  description: "Use AfterTaxPay.net's Brazil Property Tax Calculator to estimate IPTU, ITBI, and property taxes across Brazilian states and municipalities.",
  keywords: "Brazil property tax calculator, IPTU calculator, ITBI calculator, Brazilian property tax, real estate tax Brazil"
},
{
  path: "/PropertyTaxCalculatorEgypt",
  component: "PropertyTaxCalculatorEgypt",
  title: "Egypt Property Tax Calculator - Calculate Property Taxes & Real Estate Charges | AfterTaxPay.net",
  description: "Use AfterTaxPay.net's Egypt Property Tax Calculator to estimate property taxes, real estate registration fees, and municipal charges across Egyptian governorates.",
  keywords: "Egypt property tax calculator, Egyptian property tax, real estate registration tax, property tax Egypt, real estate tax calculator"
},
{
  path: "/PropertyTaxCalculatorChina",
  component: "PropertyTaxCalculatorChina",
  title: "China Property Tax Calculator - Calculate Real Estate Taxes & Deed Tax | AfterTaxPay.net",
  description: "Use AfterTaxPay.net's China Property Tax Calculator to estimate property taxes, deed tax, and real estate transaction charges across Chinese provinces and cities.",
  keywords: "China property tax calculator, Chinese property tax, deed tax calculator, real estate tax China, property transaction tax"
},
{
  path: "/PropertyTaxCalculatorColombia",
  component: "PropertyTaxCalculatorColombia",
  title: "Colombia Property Tax Calculator - Calculate Impuesto Predial & Property Taxes | AfterTaxPay.net",
  description: "Use AfterTaxPay.net's Colombia Property Tax Calculator to estimate impuesto predial, property taxes, and municipal charges across Colombian departments and municipalities.",
  keywords: "Colombia property tax calculator, impuesto predial calculator, Colombian property tax, municipal property tax, real estate tax Colombia"
},
{
  path: "/PropertyTaxCalculatorHungary",
  component: "PropertyTaxCalculatorHungary",
  title: "Hungary Property Tax Calculator - Calculate Ingatlanadó & Property Taxes | AfterTaxPay.net",
  description: "Use AfterTaxPay.net's Hungary Property Tax Calculator to estimate ingatlanadó, property taxes, and local government charges across Hungarian municipalities.",
  keywords: "Hungary property tax calculator, ingatlanadó calculator, Hungarian property tax, local property tax, real estate tax Hungary"
},
{
  path: "/PropertyTaxCalculatorHongKong",
  component: "PropertyTaxCalculatorHongKong",
  title: "Hong Kong Property Tax Calculator - Calculate Rates & Government Rent | AfterTaxPay.net",
  description: "Use AfterTaxPay.net's Hong Kong Property Tax Calculator to estimate government rates, property tax, and government rent charges across Hong Kong districts.",
  keywords: "Hong Kong property tax calculator, HK rates calculator, government rent, Hong Kong property tax, real estate tax Hong Kong"
},
{
  path: "/PropertyTaxCalculatorIndonesia",
  component: "PropertyTaxCalculatorIndonesia",
  title: "Indonesia Property Tax Calculator - Calculate PBB & BPHTB Taxes | AfterTaxPay.net",
  description: "Use AfterTaxPay.net's Indonesia Property Tax Calculator to estimate PBB (Pajak Bumi dan Bangunan), BPHTB, and property taxes across Indonesian provinces and regencies.",
  keywords: "Indonesia property tax calculator, PBB calculator, BPHTB calculator, Indonesian property tax, real estate tax Indonesia"
},
{
  path: "/PropertyTaxCalculatorMalaysia",
  component: "PropertyTaxCalculatorMalaysia",
  title: "Malaysia Property Tax Calculator - Calculate Quit Rent & Assessment Tax | AfterTaxPay.net",
  description: "Use AfterTaxPay.net's Malaysia Property Tax Calculator to estimate quit rent, assessment tax, and property charges across Malaysian states and local authorities.",
  keywords: "Malaysia property tax calculator, quit rent calculator, assessment tax Malaysia, Malaysian property tax, real estate tax Malaysia"
},
{
  path: "/PropertyTaxCalculatorPhilippines",
  component: "PropertyTaxCalculatorPhilippines",
  title: "Philippines Property Tax Calculator - Calculate Real Property Tax & Transfer Tax | AfterTaxPay.net",
  description: "Use AfterTaxPay.net's Philippines Property Tax Calculator to estimate real property tax, transfer tax, and local property charges across Philippine provinces and cities.",
  keywords: "Philippines property tax calculator, real property tax Philippines, transfer tax calculator, Philippine property tax, local property tax"
},


  // TaxReturnCalculator
  {
  path: "/TaxReturnCalculatorUSA",
  component: "TaxReturnCalculatorUSA",
  title: "US Tax Return Calculator - Estimate Your IRS Tax Refund | AfterTaxPay.net",
  description: "Use AfterTaxPay.net's US Tax Return Calculator to estimate your IRS tax refund or amount owed. Calculate federal and state tax returns with deductions and credits.",
  keywords: "US tax return calculator, IRS tax refund calculator, tax refund estimator, federal tax return, state tax return calculator"
},
{
  path: "/TaxReturnCalculatorCanada",
  component: "TaxReturnCalculatorCanada",
  title: "Canada Tax Return Calculator - Estimate Your CRA Tax Refund | AfterTaxPay.net",
  description: "Use AfterTaxPay.net's Canada Tax Return Calculator to estimate your CRA tax refund or balance owing. Calculate federal and provincial tax returns with deductions.",
  keywords: "Canada tax return calculator, CRA tax refund calculator, Canadian tax return estimator, federal tax return Canada, provincial tax return"
},
{
  path: "/TaxReturnCalculatorAustralia",
  component: "TaxReturnCalculatorAustralia",
  title: "Australia Tax Return Calculator - Estimate Your ATO Tax Refund | AfterTaxPay.net",
  description: "Use AfterTaxPay.net's Australia Tax Return Calculator to estimate your ATO tax refund or amount payable. Calculate your tax return with deductions and offsets.",
  keywords: "Australia tax return calculator, ATO tax refund calculator, Australian tax return estimator, tax refund Australia, tax return estimator"
},
{
  path: "/TaxReturnCalculatorUK",
  component: "TaxReturnCalculatorUK",
  title: "UK Tax Return Calculator - Estimate Your HMRC Tax Refund | AfterTaxPay.net",
  description: "Use AfterTaxPay.net's UK Tax Return Calculator to estimate your HMRC tax refund or amount due. Calculate self-assessment tax returns with allowances and reliefs.",
  keywords: "UK tax return calculator, HMRC tax refund calculator, self-assessment calculator, UK tax return estimator, tax refund UK"
},
{
  path: "/TaxReturnCalculatorGermany",
  component: "TaxReturnCalculatorGermany",
  title: "Germany Tax Return Calculator - Estimate Your Tax Refund (Steuererklärung) | AfterTaxPay.net",
  description: "Use AfterTaxPay.net's Germany Tax Return Calculator to estimate your tax refund or additional payment. Calculate your Steuererklärung with German tax deductions.",
  keywords: "Germany tax return calculator, German tax refund calculator, Steuererklärung calculator, tax return Germany, German tax estimator"
},
{
  path: "/TaxReturnCalculatorSwitzerland",
  component: "TaxReturnCalculatorSwitzerland",
  title: "Switzerland Tax Return Calculator - Estimate Your Tax Refund | AfterTaxPay.net",
  description: "Use AfterTaxPay.net's Switzerland Tax Return Calculator to estimate your tax refund or amount due. Calculate federal and cantonal tax returns with deductions.",
  keywords: "Switzerland tax return calculator, Swiss tax refund calculator, tax return Switzerland, cantonal tax return, Swiss tax estimator"
},
{
  path: "/TaxReturnCalculatorNorway",
  component: "TaxReturnCalculatorNorway",
  title: "Norway Tax Return Calculator - Estimate Your Tax Refund (Skatteetaten) | AfterTaxPay.net",
  description: "Use AfterTaxPay.net's Norway Tax Return Calculator to estimate your tax refund or tax due. Calculate your Norwegian tax return with deductions and allowances.",
  keywords: "Norway tax return calculator, Norwegian tax refund calculator, Skatteetaten calculator, tax return Norway, Norwegian tax estimator"
},
{
  path: "/TaxReturnCalculatorNetherlands",
  component: "TaxReturnCalculatorNetherlands",
  title: "Netherlands Tax Return Calculator - Estimate Your Tax Refund (Belastingdienst) | AfterTaxPay.net",
  description: "Use AfterTaxPay.net's Netherlands Tax Return Calculator to estimate your tax refund or payment. Calculate your Dutch tax return with deductions and credits.",
  keywords: "Netherlands tax return calculator, Dutch tax refund calculator, Belastingdienst calculator, tax return Netherlands, Dutch tax estimator"
},
{
  path: "/TaxReturnCalculatorNewZealand",
  component: "TaxReturnCalculatorNewZealand",
  title: "New Zealand Tax Return Calculator - Estimate Your IRD Tax Refund | AfterTaxPay.net",
  description: "Use AfterTaxPay.net's New Zealand Tax Return Calculator to estimate your IRD tax refund or amount to pay. Calculate your NZ tax return with deductions.",
  keywords: "New Zealand tax return calculator, NZ tax refund calculator, IRD tax return, tax return New Zealand, NZ tax estimator"
},
{
  path: "/TaxReturnCalculatorSweden",
  component: "TaxReturnCalculatorSweden",
  title: "Sweden Tax Return Calculator - Estimate Your Tax Refund (Skatteverket) | AfterTaxPay.net",
  description: "Use AfterTaxPay.net's Sweden Tax Return Calculator to estimate your tax refund or additional tax. Calculate your Swedish tax return with deductions.",
  keywords: "Sweden tax return calculator, Swedish tax refund calculator, Skatteverket calculator, tax return Sweden, Swedish tax estimator"
},
{
  path: "/TaxReturnCalculatorFrance",
  component: "TaxReturnCalculatorFrance",
  title: "France Tax Return Calculator - Estimate Your Tax Refund (Impôts) | AfterTaxPay.net",
  description: "Use AfterTaxPay.net's France Tax Return Calculator to estimate your tax refund or payment. Calculate your French tax return with deductions and credits.",
  keywords: "France tax return calculator, French tax refund calculator, impôts calculator, tax return France, French tax estimator"
},
{
  path: "/TaxReturnCalculatorItaly",
  component: "TaxReturnCalculatorItaly",
  title: "Italy Tax Return Calculator - Estimate Your Tax Refund (Agenzia delle Entrate) | AfterTaxPay.net",
  description: "Use AfterTaxPay.net's Italy Tax Return Calculator to estimate your tax refund or amount due. Calculate your Italian tax return with deductions.",
  keywords: "Italy tax return calculator, Italian tax refund calculator, Agenzia delle Entrate, tax return Italy, Italian tax estimator"
},
{
  path: "/TaxReturnCalculatorSpain",
  component: "TaxReturnCalculatorSpain",
  title: "Spain Tax Return Calculator - Estimate Your Tax Refund (Agencia Tributaria) | AfterTaxPay.net",
  description: "Use AfterTaxPay.net's Spain Tax Return Calculator to estimate your tax refund or payment. Calculate your Spanish tax return with deductions and allowances.",
  keywords: "Spain tax return calculator, Spanish tax refund calculator, Agencia Tributaria, tax return Spain, Spanish tax estimator"
},
{
  path: "/TaxReturnCalculatorIndia",
  component: "TaxReturnCalculatorIndia",
  title: "India Tax Return Calculator - Estimate Your Income Tax Refund | AfterTaxPay.net",
  description: "Use AfterTaxPay.net's India Tax Return Calculator to estimate your income tax refund or tax payable. Calculate your Indian tax return with deductions and exemptions.",
  keywords: "India tax return calculator, Indian tax refund calculator, income tax return India, tax refund India, Indian tax estimator"
},
{
  path: "/TaxReturnCalculatorJapan",
  component: "TaxReturnCalculatorJapan",
  title: "Japan Tax Return Calculator - Estimate Your Tax Refund (Kakutei Shinkoku) | AfterTaxPay.net",
  description: "Use AfterTaxPay.net's Japan Tax Return Calculator to estimate your tax refund or additional tax. Calculate your Japanese tax return with deductions.",
  keywords: "Japan tax return calculator, Japanese tax refund calculator, Kakutei Shinkoku, tax return Japan, Japanese tax estimator"
},
{
  path: "/TaxReturnCalculatorDenmark",
  component: "TaxReturnCalculatorDenmark",
  title: "Denmark Tax Return Calculator - Estimate Your Tax Refund (Skat) | AfterTaxPay.net",
  description: "Use AfterTaxPay.net's Denmark Tax Return Calculator to estimate your tax refund or tax due. Calculate your Danish tax return with deductions.",
  keywords: "Denmark tax return calculator, Danish tax refund calculator, Skat calculator, tax return Denmark, Danish tax estimator"
},
{
  path: "/TaxReturnCalculatorFinland",
  component: "TaxReturnCalculatorFinland",
  title: "Finland Tax Return Calculator - Estimate Your Tax Refund (Verotoimisto) | AfterTaxPay.net",
  description: "Use AfterTaxPay.net's Finland Tax Return Calculator to estimate your tax refund or payment. Calculate your Finnish tax return with deductions.",
  keywords: "Finland tax return calculator, Finnish tax refund calculator, Verotoimisto, tax return Finland, Finnish tax estimator"
},
{
  path: "/TaxReturnCalculatorAustria",
  component: "TaxReturnCalculatorAustria",
  title: "Austria Tax Return Calculator - Estimate Your Tax Refund (Finanzamt) | AfterTaxPay.net",
  description: "Use AfterTaxPay.net's Austria Tax Return Calculator to estimate your tax refund or amount due. Calculate your Austrian tax return with deductions.",
  keywords: "Austria tax return calculator, Austrian tax refund calculator, Finanzamt calculator, tax return Austria, Austrian tax estimator"
},
{
  path: "/TaxReturnCalculatorSingapore",
  component: "TaxReturnCalculatorSingapore",
  title: "Singapore Tax Return Calculator - Estimate Your IRAS Tax Refund | AfterTaxPay.net",
  description: "Use AfterTaxPay.net's Singapore Tax Return Calculator to estimate your IRAS tax refund or tax payable. Calculate your Singapore tax return with reliefs.",
  keywords: "Singapore tax return calculator, Singapore tax refund calculator, IRAS tax return, tax return Singapore, Singapore tax estimator"
},
{
  path: "/TaxReturnCalculatorMexico",
  component: "TaxReturnCalculatorMexico",
  title: "Mexico Tax Return Calculator - Estimate Your SAT Tax Refund | AfterTaxPay.net",
  description: "Use AfterTaxPay.net's Mexico Tax Return Calculator to estimate your SAT tax refund or amount due. Calculate your Mexican tax return with deductions.",
  keywords: "Mexico tax return calculator, Mexican tax refund calculator, SAT calculator, tax return Mexico, Mexican tax estimator"
},
{
  path: "/TaxReturnCalculatorBelgium",
  component: "TaxReturnCalculatorBelgium",
  title: "Belgium Tax Return Calculator - Estimate Your Tax Refund (FOD Financiën) | AfterTaxPay.net",
  description: "Use AfterTaxPay.net's Belgium Tax Return Calculator to estimate your tax refund or payment. Calculate your Belgian tax return with deductions.",
  keywords: "Belgium tax return calculator, Belgian tax refund calculator, FOD Financiën, tax return Belgium, Belgian tax estimator"
},
{
  path: "/TaxReturnCalculatorBrazil",
  component: "TaxReturnCalculatorBrazil",
  title: "Brazil Tax Return Calculator - Estimate Your Receita Federal Tax Refund | AfterTaxPay.net",
  description: "Use AfterTaxPay.net's Brazil Tax Return Calculator to estimate your Receita Federal tax refund or amount due. Calculate your Brazilian tax return with deductions.",
  keywords: "Brazil tax return calculator, Brazilian tax refund calculator, Receita Federal, tax return Brazil, Brazilian tax estimator"
},
{
  path: "/TaxReturnCalculatorEgypt",
  component: "TaxReturnCalculatorEgypt",
  title: "Egypt Tax Return Calculator - Estimate Your Tax Refund (ETA) | AfterTaxPay.net",
  description: "Use AfterTaxPay.net's Egypt Tax Return Calculator to estimate your tax refund or tax payable. Calculate your Egyptian tax return with deductions.",
  keywords: "Egypt tax return calculator, Egyptian tax refund calculator, Egyptian Tax Authority, tax return Egypt, Egyptian tax estimator"
},
{
  path: "/TaxReturnCalculatorChina",
  component: "TaxReturnCalculatorChina",
  title: "China Tax Return Calculator - Estimate Your Tax Refund (SAT) | AfterTaxPay.net",
  description: "Use AfterTaxPay.net's China Tax Return Calculator to estimate your tax refund or additional tax. Calculate your Chinese tax return with deductions.",
  keywords: "China tax return calculator, Chinese tax refund calculator, State Taxation Administration, tax return China, Chinese tax estimator"
},
{
  path: "/TaxReturnCalculatorColombia",
  component: "TaxReturnCalculatorColombia",
  title: "Colombia Tax Return Calculator - Estimate Your DIAN Tax Refund | AfterTaxPay.net",
  description: "Use AfterTaxPay.net's Colombia Tax Return Calculator to estimate your DIAN tax refund or amount due. Calculate your Colombian tax return with deductions.",
  keywords: "Colombia tax return calculator, Colombian tax refund calculator, DIAN calculator, tax return Colombia, Colombian tax estimator"
},
{
  path: "/TaxReturnCalculatorHungary",
  component: "TaxReturnCalculatorHungary",
  title: "Hungary Tax Return Calculator - Estimate Your NAV Tax Refund | AfterTaxPay.net",
  description: "Use AfterTaxPay.net's Hungary Tax Return Calculator to estimate your NAV tax refund or payment. Calculate your Hungarian tax return with deductions.",
  keywords: "Hungary tax return calculator, Hungarian tax refund calculator, NAV calculator, tax return Hungary, Hungarian tax estimator"
},
{
  path: "/TaxReturnCalculatorHongKong",
  component: "TaxReturnCalculatorHongKong",
  title: "Hong Kong Tax Return Calculator - Estimate Your IRD Tax Refund | AfterTaxPay.net",
  description: "Use AfterTaxPay.net's Hong Kong Tax Return Calculator to estimate your IRD tax refund or tax payable. Calculate your Hong Kong tax return with allowances.",
  keywords: "Hong Kong tax return calculator, HK tax refund calculator, IRD Hong Kong, tax return Hong Kong, HK tax estimator"
},
{
  path: "/TaxReturnCalculatorIndonesia",
  component: "TaxReturnCalculatorIndonesia",
  title: "Indonesia Tax Return Calculator - Estimate Your DJP Tax Refund | AfterTaxPay.net",
  description: "Use AfterTaxPay.net's Indonesia Tax Return Calculator to estimate your DJP tax refund or amount due. Calculate your Indonesian tax return with deductions.",
  keywords: "Indonesia tax return calculator, Indonesian tax refund calculator, Direktorat Jenderal Pajak, tax return Indonesia, Indonesian tax estimator"
},
{
  path: "/TaxReturnCalculatorMalaysia",
  component: "TaxReturnCalculatorMalaysia",
  title: "Malaysia Tax Return Calculator - Estimate Your LHDN Tax Refund | AfterTaxPay.net",
  description: "Use AfterTaxPay.net's Malaysia Tax Return Calculator to estimate your LHDN tax refund or tax payable. Calculate your Malaysian tax return with reliefs.",
  keywords: "Malaysia tax return calculator, Malaysian tax refund calculator, LHDN calculator, tax return Malaysia, Malaysian tax estimator"
},
{
  path: "/TaxReturnCalculatorPhilippines",
  component: "TaxReturnCalculatorPhilippines",
  title: "Philippines Tax Return Calculator - Estimate Your BIR Tax Refund | AfterTaxPay.net",
  description: "Use AfterTaxPay.net's Philippines Tax Return Calculator to estimate your BIR tax refund or amount due. Calculate your Philippine tax return with deductions.",
  keywords: "Philippines tax return calculator, Philippine tax refund calculator, BIR calculator, tax return Philippines, Philippine tax estimator"
},


  // Retirement Tax Calculators
  {
  path: "/RetirementTaxCalculatorUSA",
  component: "RetirementTaxCalculatorUSA",
  title: "US Retirement Tax Calculator - Estimate 401k, IRA & Social Security Taxes | AfterTaxPay.net",
  description: "Use AfterTaxPay.net's US Retirement Tax Calculator to estimate taxes on 401k, IRA withdrawals, Social Security benefits, and retirement income in the United States.",
  keywords: "US retirement tax calculator, 401k tax calculator, IRA withdrawal tax, Social Security tax, retirement income tax USA"
},
{
  path: "/RetirementTaxCalculatorCanada",
  component: "RetirementTaxCalculatorCanada",
  title: "Canada Retirement Tax Calculator - Estimate RRSP, TFSA & CPP Taxes | AfterTaxPay.net",
  description: "Use AfterTaxPay.net's Canada Retirement Tax Calculator to estimate taxes on RRSP, TFSA withdrawals, CPP benefits, and retirement income in Canada.",
  keywords: "Canada retirement tax calculator, RRSP tax calculator, TFSA withdrawal tax, CPP tax, retirement income tax Canada"
},
{
  path: "/RetirementTaxCalculatorAustralia",
  component: "RetirementTaxCalculatorAustralia",
  title: "Australia Retirement Tax Calculator - Estimate Superannuation & Pension Taxes | AfterTaxPay.net",
  description: "Use AfterTaxPay.net's Australia Retirement Tax Calculator to estimate taxes on superannuation, pension withdrawals, and retirement income in Australia.",
  keywords: "Australia retirement tax calculator, superannuation tax calculator, pension tax Australia, retirement income tax, Australian retirement tax"
},
{
  path: "/RetirementTaxCalculatorUK",
  component: "RetirementTaxCalculatorUK",
  title: "UK Retirement Tax Calculator - Estimate Pension & State Pension Taxes | AfterTaxPay.net",
  description: "Use AfterTaxPay.net's UK Retirement Tax Calculator to estimate taxes on pension withdrawals, State Pension benefits, and retirement income in the UK.",
  keywords: "UK retirement tax calculator, pension tax calculator UK, State Pension tax, retirement income tax UK, UK pension withdrawal tax"
},
{
  path: "/RetirementTaxCalculatorGermany",
  component: "RetirementTaxCalculatorGermany",
  title: "Germany Retirement Tax Calculator - Estimate Rürup, Riester & State Pension Taxes | AfterTaxPay.net",
  description: "Use AfterTaxPay.net's Germany Retirement Tax Calculator to estimate taxes on Rürup, Riester pensions, state pension benefits, and retirement income in Germany.",
  keywords: "Germany retirement tax calculator, Riester pension tax, Rürup pension tax, German pension tax, retirement income tax Germany"
},
{
  path: "/RetirementTaxCalculatorSwitzerland",
  component: "RetirementTaxCalculatorSwitzerland",
  title: "Switzerland Retirement Tax Calculator - Estimate Pillar 2 & 3 Pension Taxes | AfterTaxPay.net",
  description: "Use AfterTaxPay.net's Switzerland Retirement Tax Calculator to estimate taxes on Pillar 2, Pillar 3 pension withdrawals, and retirement income in Switzerland.",
  keywords: "Switzerland retirement tax calculator, Pillar 2 tax, Pillar 3 pension tax, Swiss retirement tax, retirement income tax Switzerland"
},
{
  path: "/RetirementTaxCalculatorNorway",
  component: "RetirementTaxCalculatorNorway",
  title: "Norway Retirement Tax Calculator - Estimate Folketrygd & Private Pension Taxes | AfterTaxPay.net",
  description: "Use AfterTaxPay.net's Norway Retirement Tax Calculator to estimate taxes on Folketrygd, private pension withdrawals, and retirement income in Norway.",
  keywords: "Norway retirement tax calculator, Folketrygd tax, Norwegian pension tax, retirement income tax Norway, private pension tax Norway"
},
{
  path: "/RetirementTaxCalculatorNetherlands",
  component: "RetirementTaxCalculatorNetherlands",
  title: "Netherlands Retirement Tax Calculator - Estimate AOW & Private Pension Taxes | AfterTaxPay.net",
  description: "Use AfterTaxPay.net's Netherlands Retirement Tax Calculator to estimate taxes on AOW benefits, private pension withdrawals, and retirement income in the Netherlands.",
  keywords: "Netherlands retirement tax calculator, AOW tax calculator, Dutch pension tax, retirement income tax Netherlands, private pension tax"
},
{
  path: "/RetirementTaxCalculatorNewZealand",
  component: "RetirementTaxCalculatorNewZealand",
  title: "New Zealand Retirement Tax Calculator - Estimate NZ Super & KiwiSaver Taxes | AfterTaxPay.net",
  description: "Use AfterTaxPay.net's New Zealand Retirement Tax Calculator to estimate taxes on NZ Super, KiwiSaver withdrawals, and retirement income in New Zealand.",
  keywords: "New Zealand retirement tax calculator, NZ Super tax, KiwiSaver tax, retirement income tax NZ, NZ pension tax"
},
{
  path: "/RetirementTaxCalculatorSweden",
  component: "RetirementTaxCalculatorSweden",
  title: "Sweden Retirement Tax Calculator - Estimate State Pension & Private Pension Taxes | AfterTaxPay.net",
  description: "Use AfterTaxPay.net's Sweden Retirement Tax Calculator to estimate taxes on state pension, private pension withdrawals, and retirement income in Sweden.",
  keywords: "Sweden retirement tax calculator, Swedish pension tax, state pension tax Sweden, retirement income tax Sweden, private pension tax"
},
{
  path: "/RetirementTaxCalculatorFrance",
  component: "RetirementTaxCalculatorFrance",
  title: "France Retirement Tax Calculator - Estimate State & Complementary Pension Taxes | AfterTaxPay.net",
  description: "Use AfterTaxPay.net's France Retirement Tax Calculator to estimate taxes on state pension, complementary pension withdrawals, and retirement income in France.",
  keywords: "France retirement tax calculator, French pension tax, state pension tax France, retirement income tax France, complementary pension tax"
},
{
  path: "/RetirementTaxCalculatorItaly",
  component: "RetirementTaxCalculatorItaly",
  title: "Italy Retirement Tax Calculator - Estimate INPS & Private Pension Taxes | AfterTaxPay.net",
  description: "Use AfterTaxPay.net's Italy Retirement Tax Calculator to estimate taxes on INPS pensions, private pension withdrawals, and retirement income in Italy.",
  keywords: "Italy retirement tax calculator, INPS pension tax, Italian pension tax, retirement income tax Italy, private pension tax Italy"
},
{
  path: "/RetirementTaxCalculatorSpain",
  component: "RetirementTaxCalculatorSpain",
  title: "Spain Retirement Tax Calculator - Estimate State & Private Pension Taxes | AfterTaxPay.net",
  description: "Use AfterTaxPay.net's Spain Retirement Tax Calculator to estimate taxes on state pension, private pension withdrawals, and retirement income in Spain.",
  keywords: "Spain retirement tax calculator, Spanish pension tax, state pension tax Spain, retirement income tax Spain, private pension tax"
},
{
  path: "/RetirementTaxCalculatorIndia",
  component: "RetirementTaxCalculatorIndia",
  title: "India Retirement Tax Calculator - Estimate NPS, EPF & Pension Taxes | AfterTaxPay.net",
  description: "Use AfterTaxPay.net's India Retirement Tax Calculator to estimate taxes on NPS, EPF withdrawals, pension income, and retirement benefits in India.",
  keywords: "India retirement tax calculator, NPS tax calculator, EPF withdrawal tax, Indian pension tax, retirement income tax India"
},
{
  path: "/RetirementTaxCalculatorJapan",
  component: "RetirementTaxCalculatorJapan",
  title: "Japan Retirement Tax Calculator - Estimate National Pension & Private Pension Taxes | AfterTaxPay.net",
  description: "Use AfterTaxPay.net's Japan Retirement Tax Calculator to estimate taxes on national pension, private pension withdrawals, and retirement income in Japan.",
  keywords: "Japan retirement tax calculator, Japanese pension tax, national pension tax Japan, retirement income tax Japan, private pension tax"
},
{
  path: "/RetirementTaxCalculatorDenmark",
  component: "RetirementTaxCalculatorDenmark",
  title: "Denmark Retirement Tax Calculator - Estimate State & Private Pension Taxes | AfterTaxPay.net",
  description: "Use AfterTaxPay.net's Denmark Retirement Tax Calculator to estimate taxes on state pension, private pension withdrawals, and retirement income in Denmark.",
  keywords: "Denmark retirement tax calculator, Danish pension tax, state pension tax Denmark, retirement income tax Denmark, private pension tax"
},
{
  path: "/RetirementTaxCalculatorFinland",
  component: "RetirementTaxCalculatorFinland",
  title: "Finland Retirement Tax Calculator - Estimate National & Private Pension Taxes | AfterTaxPay.net",
  description: "Use AfterTaxPay.net's Finland Retirement Tax Calculator to estimate taxes on national pension, private pension withdrawals, and retirement income in Finland.",
  keywords: "Finland retirement tax calculator, Finnish pension tax, national pension tax Finland, retirement income tax Finland, private pension tax"
},
{
  path: "/RetirementTaxCalculatorAustria",
  component: "RetirementTaxCalculatorAustria",
  title: "Austria Retirement Tax Calculator - Estimate State & Private Pension Taxes | AfterTaxPay.net",
  description: "Use AfterTaxPay.net's Austria Retirement Tax Calculator to estimate taxes on state pension, private pension withdrawals, and retirement income in Austria.",
  keywords: "Austria retirement tax calculator, Austrian pension tax, state pension tax Austria, retirement income tax Austria, private pension tax"
},
{
  path: "/RetirementTaxCalculatorSingapore",
  component: "RetirementTaxCalculatorSingapore",
  title: "Singapore Retirement Tax Calculator - Estimate CPF & Private Pension Taxes | AfterTaxPay.net",
  description: "Use AfterTaxPay.net's Singapore Retirement Tax Calculator to estimate taxes on CPF withdrawals, private pension income, and retirement benefits in Singapore.",
  keywords: "Singapore retirement tax calculator, CPF withdrawal tax, Singapore pension tax, retirement income tax Singapore, private pension tax"
},
{
  path: "/RetirementTaxCalculatorMexico",
  component: "RetirementTaxCalculatorMexico",
  title: "Mexico Retirement Tax Calculator - Estimate AFORE & Private Pension Taxes | AfterTaxPay.net",
  description: "Use AfterTaxPay.net's Mexico Retirement Tax Calculator to estimate taxes on AFORE withdrawals, private pension income, and retirement benefits in Mexico.",
  keywords: "Mexico retirement tax calculator, AFORE tax calculator, Mexican pension tax, retirement income tax Mexico, private pension tax"
},
{
  path: "/RetirementTaxCalculatorBelgium",
  component: "RetirementTaxCalculatorBelgium",
  title: "Belgium Retirement Tax Calculator - Estimate State & Private Pension Taxes | AfterTaxPay.net",
  description: "Use AfterTaxPay.net's Belgium Retirement Tax Calculator to estimate taxes on state pension, private pension withdrawals, and retirement income in Belgium.",
  keywords: "Belgium retirement tax calculator, Belgian pension tax, state pension tax Belgium, retirement income tax Belgium, private pension tax"
},
{
  path: "/RetirementTaxCalculatorBrasil",
  component: "RetirementTaxCalculatorBrasil",
  title: "Brazil Retirement Tax Calculator - Estimate INSS & Private Pension Taxes | AfterTaxPay.net",
  description: "Use AfterTaxPay.net's Brazil Retirement Tax Calculator to estimate taxes on INSS benefits, private pension withdrawals, and retirement income in Brazil.",
  keywords: "Brazil retirement tax calculator, INSS tax calculator, Brazilian pension tax, retirement income tax Brazil, private pension tax"
},
{
  path: "/RetirementTaxCalculatorEgypt",
  component: "RetirementTaxCalculatorEgypt",
  title: "Egypt Retirement Tax Calculator - Estimate Social Insurance & Private Pension Taxes | AfterTaxPay.net",
  description: "Use AfterTaxPay.net's Egypt Retirement Tax Calculator to estimate taxes on social insurance benefits, private pension withdrawals, and retirement income in Egypt.",
  keywords: "Egypt retirement tax calculator, Egyptian pension tax, social insurance tax Egypt, retirement income tax Egypt, private pension tax"
},
{
  path: "/RetirementTaxCalculatorChina",
  component: "RetirementTaxCalculatorChina",
  title: "China Retirement Tax Calculator - Estimate State & Private Pension Taxes | AfterTaxPay.net",
  description: "Use AfterTaxPay.net's China Retirement Tax Calculator to estimate taxes on state pension, private pension withdrawals, and retirement income in China.",
  keywords: "China retirement tax calculator, Chinese pension tax, state pension tax China, retirement income tax China, private pension tax"
},
{
  path: "/RetirementTaxCalculatorColombia",
  component: "RetirementTaxCalculatorColombia",
  title: "Colombia Retirement Tax Calculator - Estimate State & Private Pension Taxes | AfterTaxPay.net",
  description: "Use AfterTaxPay.net's Colombia Retirement Tax Calculator to estimate taxes on state pension, private pension withdrawals, and retirement income in Colombia.",
  keywords: "Colombia retirement tax calculator, Colombian pension tax, state pension tax Colombia, retirement income tax Colombia, private pension tax"
},
{
  path: "/RetirementTaxCalculatorHungary",
  component: "RetirementTaxCalculatorHungary",
  title: "Hungary Retirement Tax Calculator - Estimate State & Private Pension Taxes | AfterTaxPay.net",
  description: "Use AfterTaxPay.net's Hungary Retirement Tax Calculator to estimate taxes on state pension, private pension withdrawals, and retirement income in Hungary.",
  keywords: "Hungary retirement tax calculator, Hungarian pension tax, state pension tax Hungary, retirement income tax Hungary, private pension tax"
},
{
  path: "/RetirementTaxCalculatorHongKong",
  component: "RetirementTaxCalculatorHongKong",
  title: "Hong Kong Retirement Tax Calculator - Estimate MPF & Private Pension Taxes | AfterTaxPay.net",
  description: "Use AfterTaxPay.net's Hong Kong Retirement Tax Calculator to estimate taxes on MPF withdrawals, private pension income, and retirement benefits in Hong Kong.",
  keywords: "Hong Kong retirement tax calculator, MPF withdrawal tax, HK pension tax, retirement income tax Hong Kong, private pension tax"
},
{
  path: "/RetirementTaxCalculatorIndonesia",
  component: "RetirementTaxCalculatorIndonesia",
  title: "Indonesia Retirement Tax Calculator - Estimate BPJS & Private Pension Taxes | AfterTaxPay.net",
  description: "Use AfterTaxPay.net's Indonesia Retirement Tax Calculator to estimate taxes on BPJS benefits, private pension withdrawals, and retirement income in Indonesia.",
  keywords: "Indonesia retirement tax calculator, BPJS tax calculator, Indonesian pension tax, retirement income tax Indonesia, private pension tax"
},
{
  path: "/RetirementTaxCalculatorMalaysia",
  component: "RetirementTaxCalculatorMalaysia",
  title: "Malaysia Retirement Tax Calculator - Estimate EPF & Private Pension Taxes | AfterTaxPay.net",
  description: "Use AfterTaxPay.net's Malaysia Retirement Tax Calculator to estimate taxes on EPF withdrawals, private pension income, and retirement benefits in Malaysia.",
  keywords: "Malaysia retirement tax calculator, EPF withdrawal tax, Malaysian pension tax, retirement income tax Malaysia, private pension tax"
},
{
  path: "/RetirementTaxCalculatorPhilippines",
  component: "RetirementTaxCalculatorPhilippines",
  title: "Philippines Retirement Tax Calculator - Estimate SSS, GSIS & Private Pension Taxes | AfterTaxPay.net",
  description: "Use AfterTaxPay.net's Philippines Retirement Tax Calculator to estimate taxes on SSS, GSIS benefits, private pension withdrawals, and retirement income in the Philippines.",
  keywords: "Philippines retirement tax calculator, SSS tax calculator, GSIS tax, Philippine pension tax, retirement income tax Philippines"
},


  // InheritanceTaxCalculator
  {
  path: "/InheritanceTaxCalculatorUSA",
  component: "InheritanceTaxCalculatorUSA",
  title: "US Inheritance Tax Calculator - Federal & State Estate Tax Calculator | AfterTaxPay.net",
  description: "Use AfterTaxPay.net's US Inheritance Tax Calculator to estimate federal estate tax, state inheritance taxes, and estate settlement costs for beneficiaries in the United States.",
  keywords: "US inheritance tax calculator, estate tax calculator USA, federal estate tax, state inheritance tax, estate planning calculator"
},
{
  path: "/InheritanceTaxCalculatorCanada",
  component: "InheritanceTaxCalculatorCanada",
  title: "Canada Inheritance Tax Calculator - Probate Fees & Estate Tax Calculator | AfterTaxPay.net",
  description: "Use AfterTaxPay.net's Canada Inheritance Tax Calculator to estimate probate fees, estate administration taxes, and inheritance costs for beneficiaries in Canada.",
  keywords: "Canada inheritance tax calculator, probate fees calculator, estate tax Canada, inheritance tax calculator, Canadian estate planning"
},
{
  path: "/InheritanceTaxCalculatorAustralia",
  component: "InheritanceTaxCalculatorAustralia",
  title: "Australia Inheritance Tax Calculator - Capital Gains & Estate Tax Calculator | AfterTaxPay.net",
  description: "Use AfterTaxPay.net's Australia Inheritance Tax Calculator to estimate capital gains tax on inherited assets, estate costs, and inheritance taxes in Australia.",
  keywords: "Australia inheritance tax calculator, capital gains tax inheritance, estate tax Australia, inheritance calculator, Australian estate planning"
},
{
  path: "/InheritanceTaxCalculatorUK",
  component: "InheritanceTaxCalculatorUK",
  title: "UK Inheritance Tax Calculator - IHT Calculator & Estate Tax Calculator | AfterTaxPay.net",
  description: "Use AfterTaxPay.net's UK Inheritance Tax Calculator to estimate Inheritance Tax (IHT), estate taxes, and inheritance costs for beneficiaries in the United Kingdom.",
  keywords: "UK inheritance tax calculator, IHT calculator, estate tax UK, inheritance tax UK, British estate planning"
},
{
  path: "/InheritanceTaxCalculatorGermany",
  component: "InheritanceTaxCalculatorGermany",
  title: "Germany Inheritance Tax Calculator - Erbschaftsteuer Calculator | AfterTaxPay.net",
  description: "Use AfterTaxPay.net's Germany Inheritance Tax Calculator to estimate Erbschaftsteuer (inheritance tax), estate taxes, and inheritance costs for beneficiaries in Germany.",
  keywords: "Germany inheritance tax calculator, Erbschaftsteuer calculator, German inheritance tax, estate tax Germany, German estate planning"
},
{
  path: "/InheritanceTaxCalculatorSwitzerland",
  component: "InheritanceTaxCalculatorSwitzerland",
  title: "Switzerland Inheritance Tax Calculator - Cantonal Inheritance Tax Calculator | AfterTaxPay.net",
  description: "Use AfterTaxPay.net's Switzerland Inheritance Tax Calculator to estimate cantonal inheritance taxes, estate taxes, and inheritance costs for beneficiaries in Switzerland.",
  keywords: "Switzerland inheritance tax calculator, cantonal inheritance tax, Swiss inheritance tax, estate tax Switzerland, Swiss estate planning"
},
{
  path: "/InheritanceTaxCalculatorNorway",
  component: "InheritanceTaxCalculatorNorway",
  title: "Norway Inheritance Tax Calculator - Arveavgift Calculator | AfterTaxPay.net",
  description: "Use AfterTaxPay.net's Norway Inheritance Tax Calculator to estimate arveavgift (inheritance tax), estate taxes, and inheritance costs for beneficiaries in Norway.",
  keywords: "Norway inheritance tax calculator, arveavgift calculator, Norwegian inheritance tax, estate tax Norway, Norwegian estate planning"
},
{
  path: "/InheritanceTaxCalculatorNetherlands",
  component: "InheritanceTaxCalculatorNetherlands",
  title: "Netherlands Inheritance Tax Calculator - Successiebelasting Calculator | AfterTaxPay.net",
  description: "Use AfterTaxPay.net's Netherlands Inheritance Tax Calculator to estimate successiebelasting (inheritance tax), estate taxes, and inheritance costs for beneficiaries in the Netherlands.",
  keywords: "Netherlands inheritance tax calculator, successiebelasting calculator, Dutch inheritance tax, estate tax Netherlands, Dutch estate planning"
},
{
  path: "/InheritanceTaxCalculatorNewZealand",
  component: "InheritanceTaxCalculatorNewZealand",
  title: "New Zealand Inheritance Tax Calculator - Estate Tax & Inheritance Calculator | AfterTaxPay.net",
  description: "Use AfterTaxPay.net's New Zealand Inheritance Tax Calculator to estimate estate taxes, inheritance costs, and estate administration fees for beneficiaries in New Zealand.",
  keywords: "New Zealand inheritance tax calculator, estate tax NZ, inheritance calculator NZ, NZ estate planning, estate administration fees"
},
{
  path: "/InheritanceTaxCalculatorSweden",
  component: "InheritanceTaxCalculatorSweden",
  title: "Sweden Inheritance Tax Calculator - Arvsskatt Calculator | AfterTaxPay.net",
  description: "Use AfterTaxPay.net's Sweden Inheritance Tax Calculator to estimate arvsskatt (inheritance tax), estate taxes, and inheritance costs for beneficiaries in Sweden.",
  keywords: "Sweden inheritance tax calculator, arvsskatt calculator, Swedish inheritance tax, estate tax Sweden, Swedish estate planning"
},
{
  path: "/InheritanceTaxCalculatorFrance",
  component: "InheritanceTaxCalculatorFrance",
  title: "France Inheritance Tax Calculator - Droits de Succession Calculator | AfterTaxPay.net",
  description: "Use AfterTaxPay.net's France Inheritance Tax Calculator to estimate droits de succession (inheritance tax), estate taxes, and inheritance costs for beneficiaries in France.",
  keywords: "France inheritance tax calculator, droits de succession calculator, French inheritance tax, estate tax France, French estate planning"
},
{
  path: "/InheritanceTaxCalculatorItaly",
  component: "InheritanceTaxCalculatorItaly",
  title: "Italy Inheritance Tax Calculator - Tasse di Successione Calculator | AfterTaxPay.net",
  description: "Use AfterTaxPay.net's Italy Inheritance Tax Calculator to estimate tasse di successione (inheritance tax), estate taxes, and inheritance costs for beneficiaries in Italy.",
  keywords: "Italy inheritance tax calculator, tasse di successione calculator, Italian inheritance tax, estate tax Italy, Italian estate planning"
},
{
  path: "/InheritanceTaxCalculatorSpain",
  component: "InheritanceTaxCalculatorSpain",
  title: "Spain Inheritance Tax Calculator - Impuesto de Sucesiones Calculator | AfterTaxPay.net",
  description: "Use AfterTaxPay.net's Spain Inheritance Tax Calculator to estimate impuesto de sucesiones (inheritance tax), estate taxes, and inheritance costs for beneficiaries in Spain.",
  keywords: "Spain inheritance tax calculator, impuesto de sucesiones calculator, Spanish inheritance tax, estate tax Spain, Spanish estate planning"
},
{
  path: "/InheritanceTaxCalculatorIndia",
  component: "InheritanceTaxCalculatorIndia",
  title: "India Inheritance Tax Calculator - Estate Tax & Inheritance Calculator | AfterTaxPay.net",
  description: "Use AfterTaxPay.net's India Inheritance Tax Calculator to estimate estate taxes, inheritance costs, and capital gains tax on inherited assets in India.",
  keywords: "India inheritance tax calculator, estate tax India, inheritance calculator India, Indian estate planning, capital gains inheritance"
},
{
  path: "/InheritanceTaxCalculatorJapan",
  component: "InheritanceTaxCalculatorJapan",
  title: "Japan Inheritance Tax Calculator - Sōzokuzei Calculator | AfterTaxPay.net",
  description: "Use AfterTaxPay.net's Japan Inheritance Tax Calculator to estimate sōzokuzei (inheritance tax), estate taxes, and inheritance costs for beneficiaries in Japan.",
  keywords: "Japan inheritance tax calculator, sōzokuzei calculator, Japanese inheritance tax, estate tax Japan, Japanese estate planning"
},
{
  path: "/InheritanceTaxCalculatorDenmark",
  component: "InheritanceTaxCalculatorDenmark",
  title: "Denmark Inheritance Tax Calculator - Arveafgift Calculator | AfterTaxPay.net",
  description: "Use AfterTaxPay.net's Denmark Inheritance Tax Calculator to estimate arveafgift (inheritance tax), estate taxes, and inheritance costs for beneficiaries in Denmark.",
  keywords: "Denmark inheritance tax calculator, arveafgift calculator, Danish inheritance tax, estate tax Denmark, Danish estate planning"
},
{
  path: "/InheritanceTaxCalculatorFinland",
  component: "InheritanceTaxCalculatorFinland",
  title: "Finland Inheritance Tax Calculator - Perintövero Calculator | AfterTaxPay.net",
  description: "Use AfterTaxPay.net's Finland Inheritance Tax Calculator to estimate perintövero (inheritance tax), estate taxes, and inheritance costs for beneficiaries in Finland.",
  keywords: "Finland inheritance tax calculator, perintövero calculator, Finnish inheritance tax, estate tax Finland, Finnish estate planning"
},
{
  path: "/InheritanceTaxCalculatorAustria",
  component: "InheritanceTaxCalculatorAustria",
  title: "Austria Inheritance Tax Calculator - Erbschaftssteuer Calculator | AfterTaxPay.net",
  description: "Use AfterTaxPay.net's Austria Inheritance Tax Calculator to estimate Erbschaftssteuer (inheritance tax), estate taxes, and inheritance costs for beneficiaries in Austria.",
  keywords: "Austria inheritance tax calculator, Erbschaftssteuer calculator, Austrian inheritance tax, estate tax Austria, Austrian estate planning"
},
{
  path: "/InheritanceTaxCalculatorSingapore",
  component: "InheritanceTaxCalculatorSingapore",
  title: "Singapore Inheritance Tax Calculator - Estate Tax & Probate Calculator | AfterTaxPay.net",
  description: "Use AfterTaxPay.net's Singapore Inheritance Tax Calculator to estimate estate taxes, probate fees, and estate administration costs for beneficiaries in Singapore.",
  keywords: "Singapore inheritance tax calculator, estate tax Singapore, probate calculator Singapore, Singapore estate planning, estate administration"
},
{
  path: "/InheritanceTaxCalculatorMexico",
  component: "InheritanceTaxCalculatorMexico",
  title: "Mexico Inheritance Tax Calculator - Impuesto de Sucesiones Calculator | AfterTaxPay.net",
  description: "Use AfterTaxPay.net's Mexico Inheritance Tax Calculator to estimate impuesto de sucesiones (inheritance tax), estate taxes, and inheritance costs for beneficiaries in Mexico.",
  keywords: "Mexico inheritance tax calculator, impuesto de sucesiones calculator, Mexican inheritance tax, estate tax Mexico, Mexican estate planning"
},
{
  path: "/InheritanceTaxCalculatorBelgium",
  component: "InheritanceTaxCalculatorBelgium",
  title: "Belgium Inheritance Tax Calculator - Succesierechten Calculator | AfterTaxPay.net",
  description: "Use AfterTaxPay.net's Belgium Inheritance Tax Calculator to estimate succesierechten (inheritance tax), estate taxes, and inheritance costs for beneficiaries in Belgium.",
  keywords: "Belgium inheritance tax calculator, succesierechten calculator, Belgian inheritance tax, estate tax Belgium, Belgian estate planning"
},
{
  path: "/InheritanceTaxCalculatorBrasil",
  component: "InheritanceTaxCalculatorBrasil",
  title: "Brazil Inheritance Tax Calculator - ITCMD & Estate Tax Calculator | AfterTaxPay.net",
  description: "Use AfterTaxPay.net's Brazil Inheritance Tax Calculator to estimate ITCMD (inheritance tax), estate taxes, and inheritance costs for beneficiaries in Brazil.",
  keywords: "Brazil inheritance tax calculator, ITCMD calculator, Brazilian inheritance tax, estate tax Brazil, Brazilian estate planning"
},
{
  path: "/InheritanceTaxCalculatorEgypt",
  component: "InheritanceTaxCalculatorEgypt",
  title: "Egypt Inheritance Tax Calculator - Inheritance Tax & Estate Calculator | AfterTaxPay.net",
  description: "Use AfterTaxPay.net's Egypt Inheritance Tax Calculator to estimate inheritance taxes, estate costs, and inheritance settlement fees for beneficiaries in Egypt.",
  keywords: "Egypt inheritance tax calculator, Egyptian inheritance tax, estate tax Egypt, inheritance calculator Egypt, Egyptian estate planning"
},
{
  path: "/InheritanceTaxCalculatorChina",
  component: "InheritanceTaxCalculatorChina",
  title: "China Inheritance Tax Calculator - Estate Tax & Inheritance Calculator | AfterTaxPay.net",
  description: "Use AfterTaxPay.net's China Inheritance Tax Calculator to estimate estate taxes, inheritance costs, and asset transfer taxes for beneficiaries in China.",
  keywords: "China inheritance tax calculator, estate tax China, inheritance calculator China, Chinese estate planning, asset transfer tax"
},
{
  path: "/InheritanceTaxCalculatorColombia",
  component: "InheritanceTaxCalculatorColombia",
  title: "Colombia Inheritance Tax Calculator - Impuesto de Sucesiones Calculator | AfterTaxPay.net",
  description: "Use AfterTaxPay.net's Colombia Inheritance Tax Calculator to estimate impuesto de sucesiones (inheritance tax), estate taxes, and inheritance costs for beneficiaries in Colombia.",
  keywords: "Colombia inheritance tax calculator, impuesto de sucesiones calculator, Colombian inheritance tax, estate tax Colombia, Colombian estate planning"
},
{
  path: "/InheritanceTaxCalculatorHungary",
  component: "InheritanceTaxCalculatorHungary",
  title: "Hungary Inheritance Tax Calculator - Öröklési Adó Calculator | AfterTaxPay.net",
  description: "Use AfterTaxPay.net's Hungary Inheritance Tax Calculator to estimate öröklési adó (inheritance tax), estate taxes, and inheritance costs for beneficiaries in Hungary.",
  keywords: "Hungary inheritance tax calculator, öröklési adó calculator, Hungarian inheritance tax, estate tax Hungary, Hungarian estate planning"
},
{
  path: "/InheritanceTaxCalculatorHongKong",
  component: "InheritanceTaxCalculatorHongKong",
  title: "Hong Kong Inheritance Tax Calculator - Estate Duty & Probate Calculator | AfterTaxPay.net",
  description: "Use AfterTaxPay.net's Hong Kong Inheritance Tax Calculator to estimate estate duty, probate fees, and estate administration costs for beneficiaries in Hong Kong.",
  keywords: "Hong Kong inheritance tax calculator, estate duty Hong Kong, probate calculator HK, HK estate planning, estate administration Hong Kong"
},
{
  path: "/InheritanceTaxCalculatorIndonesia",
  component: "InheritanceTaxCalculatorIndonesia",
  title: "Indonesia Inheritance Tax Calculator - Waris & Estate Tax Calculator | AfterTaxPay.net",
  description: "Use AfterTaxPay.net's Indonesia Inheritance Tax Calculator to estimate waris taxes, estate taxes, and inheritance costs for beneficiaries in Indonesia.",
  keywords: "Indonesia inheritance tax calculator, waris tax calculator, Indonesian inheritance tax, estate tax Indonesia, Indonesian estate planning"
},
{
  path: "/InheritanceTaxCalculatorMalaysia",
  component: "InheritanceTaxCalculatorMalaysia",
  title: "Malaysia Inheritance Tax Calculator - Estate Administration & Probate Calculator | AfterTaxPay.net",
  description: "Use AfterTaxPay.net's Malaysia Inheritance Tax Calculator to estimate estate administration costs, probate fees, and inheritance taxes for beneficiaries in Malaysia.",
  keywords: "Malaysia inheritance tax calculator, estate administration Malaysia, probate calculator Malaysia, Malaysian estate planning, inheritance tax Malaysia"
},
{
  path: "/InheritanceTaxCalculatorPhilippines",
  component: "InheritanceTaxCalculatorPhilippines",
  title: "Philippines Inheritance Tax Calculator - Estate Tax & Donor's Tax Calculator | AfterTaxPay.net",
  description: "Use AfterTaxPay.net's Philippines Inheritance Tax Calculator to estimate estate tax, donor's tax, and inheritance costs for beneficiaries in the Philippines.",
  keywords: "Philippines inheritance tax calculator, estate tax Philippines, donor's tax calculator, Philippine estate planning, inheritance tax Philippines"
},


  // CapitalGainsCalculator
  {
  path: "/CapitalGainsCalculatorUSA",
  component: "CapitalGainsCalculatorUSA",
  title: "US Capital Gains Tax Calculator - Stocks, Real Estate & Investments | AfterTaxPay.net",
  description: "Use AfterTaxPay.net's US Capital Gains Tax Calculator to estimate taxes on stocks, real estate, and investments. Calculate short-term and long-term capital gains tax rates.",
  keywords: "US capital gains tax calculator, stock tax calculator, real estate capital gains, investment tax calculator, long-term capital gains"
},
{
  path: "/CapitalGainsCalculatorCanada",
  component: "CapitalGainsCalculatorCanada",
  title: "Canada Capital Gains Tax Calculator - Stocks, Real Estate & Investments | AfterTaxPay.net",
  description: "Use AfterTaxPay.net's Canada Capital Gains Tax Calculator to estimate taxes on stocks, real estate, and investments. Calculate Canadian capital gains inclusion rates and taxes.",
  keywords: "Canada capital gains tax calculator, Canadian stock tax, real estate capital gains Canada, investment tax calculator, capital gains inclusion rate"
},
{
  path: "/CapitalGainsCalculatorAustralia",
  component: "CapitalGainsCalculatorAustralia",
  title: "Australia Capital Gains Tax Calculator - CGT Calculator for Assets | AfterTaxPay.net",
  description: "Use AfterTaxPay.net's Australia Capital Gains Tax Calculator to estimate CGT on property, shares, and assets. Calculate discounts for long-term holdings.",
  keywords: "Australia capital gains tax calculator, CGT calculator Australia, property CGT, share tax calculator, Australian investment tax"
},
{
  path: "/CapitalGainsCalculatorUK",
  component: "CapitalGainsCalculatorUK",
  title: "UK Capital Gains Tax Calculator - CGT Calculator for Assets & Property | AfterTaxPay.net",
  description: "Use AfterTaxPay.net's UK Capital Gains Tax Calculator to estimate CGT on property, shares, and assets. Calculate UK capital gains tax allowances and rates.",
  keywords: "UK capital gains tax calculator, CGT calculator UK, property CGT UK, share tax calculator, UK investment tax"
},
{
  path: "/CapitalGainsCalculatorGermany",
  component: "CapitalGainsCalculatorGermany",
  title: "Germany Capital Gains Tax Calculator - Abgeltungsteuer & Investment Tax | AfterTaxPay.net",
  description: "Use AfterTaxPay.net's Germany Capital Gains Tax Calculator to estimate Abgeltungsteuer on stocks, funds, and investments. Calculate German capital gains taxes.",
  keywords: "Germany capital gains tax calculator, Abgeltungsteuer calculator, German stock tax, investment tax Germany, capital gains tax Germany"
},
{
  path: "/CapitalGainsCalculatorSwitzerland",
  component: "CapitalGainsCalculatorSwitzerland",
  title: "Switzerland Capital Gains Tax Calculator - Real Estate & Investment Gains | AfterTaxPay.net",
  description: "Use AfterTaxPay.net's Switzerland Capital Gains Tax Calculator to estimate taxes on real estate gains, securities, and investments. Calculate Swiss capital gains taxes.",
  keywords: "Switzerland capital gains tax calculator, Swiss real estate tax, investment gains Switzerland, securities tax, Swiss capital gains"
},
{
  path: "/CapitalGainsCalculatorNorway",
  component: "CapitalGainsCalculatorNorway",
  title: "Norway Capital Gains Tax Calculator - Real Estate & Financial Assets | AfterTaxPay.net",
  description: "Use AfterTaxPay.net's Norway Capital Gains Tax Calculator to estimate taxes on real estate, stocks, and financial assets. Calculate Norwegian capital gains taxes.",
  keywords: "Norway capital gains tax calculator, Norwegian real estate tax, stock tax Norway, financial asset tax, capital gains tax Norway"
},
{
  path: "/CapitalGainsCalculatorNetherlands",
  component: "CapitalGainsCalculatorNetherlands",
  title: "Netherlands Capital Gains Tax Calculator - Box 3 Tax Calculator | AfterTaxPay.net",
  description: "Use AfterTaxPay.net's Netherlands Capital Gains Tax Calculator to estimate Box 3 wealth tax on investments and assets. Calculate Dutch capital gains taxation.",
  keywords: "Netherlands capital gains tax calculator, Box 3 tax calculator, Dutch investment tax, wealth tax Netherlands, capital gains tax Netherlands"
},
{
  path: "/CapitalGainsCalculatorNewZealand",
  component: "CapitalGainsCalculatorNewZealand",
  title: "New Zealand Capital Gains Tax Calculator - Bright-line Test & Property | AfterTaxPay.net",
  description: "Use AfterTaxPay.net's New Zealand Capital Gains Tax Calculator to estimate taxes under bright-line test, property gains, and investment income.",
  keywords: "New Zealand capital gains tax calculator, bright-line test calculator, NZ property tax, investment tax New Zealand, capital gains tax NZ"
},
{
  path: "/CapitalGainsCalculatorSweden",
  component: "CapitalGainsCalculatorSweden",
  title: "Sweden Capital Gains Tax Calculator - Real Estate & Securities Tax | AfterTaxPay.net",
  description: "Use AfterTaxPay.net's Sweden Capital Gains Tax Calculator to estimate taxes on real estate, securities, and investment gains. Calculate Swedish capital gains taxes.",
  keywords: "Sweden capital gains tax calculator, Swedish real estate tax, securities tax Sweden, investment gains tax, capital gains tax Sweden"
},
{
  path: "/CapitalGainsCalculatorFrance",
  component: "CapitalGainsCalculatorFrance",
  title: "France Capital Gains Tax Calculator - Plus-values & Real Estate Tax | AfterTaxPay.net",
  description: "Use AfterTaxPay.net's France Capital Gains Tax Calculator to estimate plus-values on real estate, stocks, and assets. Calculate French capital gains taxes.",
  keywords: "France capital gains tax calculator, plus-values calculator, French real estate tax, stock tax France, capital gains tax France"
},
{
  path: "/CapitalGainsCalculatorItaly",
  component: "CapitalGainsCalculatorItaly",
  title: "Italy Capital Gains Tax Calculator - Capital Gains & Financial Assets | AfterTaxPay.net",
  description: "Use AfterTaxPay.net's Italy Capital Gains Tax Calculator to estimate taxes on capital gains, financial assets, and real estate. Calculate Italian capital gains taxes.",
  keywords: "Italy capital gains tax calculator, Italian investment tax, financial asset tax Italy, real estate gains tax, capital gains tax Italy"
},
{
  path: "/CapitalGainsCalculatorSpain",
  component: "CapitalGainsCalculatorSpain",
  title: "Spain Capital Gains Tax Calculator - Plusvalías & Real Estate Tax | AfterTaxPay.net",
  description: "Use AfterTaxPay.net's Spain Capital Gains Tax Calculator to estimate plusvalías on real estate, investments, and assets. Calculate Spanish capital gains taxes.",
  keywords: "Spain capital gains tax calculator, plusvalías calculator, Spanish real estate tax, investment tax Spain, capital gains tax Spain"
},
{
  path: "/CapitalGainsCalculatorIndia",
  component: "CapitalGainsCalculatorIndia",
  title: "India Capital Gains Tax Calculator - LTCG, STCG & Property Tax | AfterTaxPay.net",
  description: "Use AfterTaxPay.net's India Capital Gains Tax Calculator to estimate LTCG, STCG on stocks, mutual funds, and property. Calculate Indian capital gains taxes.",
  keywords: "India capital gains tax calculator, LTCG calculator, STCG calculator, property capital gains India, Indian investment tax"
},
{
  path: "/CapitalGainsCalculatorJapan",
  component: "CapitalGainsCalculatorJapan",
  title: "Japan Capital Gains Tax Calculator - Stocks, Real Estate & Investments | AfterTaxPay.net",
  description: "Use AfterTaxPay.net's Japan Capital Gains Tax Calculator to estimate taxes on stocks, real estate, and investments. Calculate Japanese capital gains tax rates.",
  keywords: "Japan capital gains tax calculator, Japanese stock tax, real estate tax Japan, investment tax Japan, capital gains tax Japan"
},
{
  path: "/CapitalGainsCalculatorDenmark",
  component: "CapitalGainsCalculatorDenmark",
  title: "Denmark Capital Gains Tax Calculator - Real Estate & Securities Gains | AfterTaxPay.net",
  description: "Use AfterTaxPay.net's Denmark Capital Gains Tax Calculator to estimate taxes on real estate, securities, and investment gains. Calculate Danish capital gains taxes.",
  keywords: "Denmark capital gains tax calculator, Danish real estate tax, securities tax Denmark, investment gains tax, capital gains tax Denmark"
},
{
  path: "/CapitalGainsCalculatorFinland",
  component: "CapitalGainsCalculatorFinland",
  title: "Finland Capital Gains Tax Calculator - Real Estate & Investment Gains | AfterTaxPay.net",
  description: "Use AfterTaxPay.net's Finland Capital Gains Tax Calculator to estimate taxes on real estate, investments, and asset sales. Calculate Finnish capital gains taxes.",
  keywords: "Finland capital gains tax calculator, Finnish real estate tax, investment tax Finland, asset sale tax, capital gains tax Finland"
},
{
  path: "/CapitalGainsCalculatorAustria",
  component: "CapitalGainsCalculatorAustria",
  title: "Austria Capital Gains Tax Calculator - Investment & Real Estate Gains | AfterTaxPay.net",
  description: "Use AfterTaxPay.net's Austria Capital Gains Tax Calculator to estimate taxes on investments, real estate, and asset sales. Calculate Austrian capital gains taxes.",
  keywords: "Austria capital gains tax calculator, Austrian investment tax, real estate tax Austria, asset sale tax, capital gains tax Austria"
},
{
  path: "/CapitalGainsCalculatorSingapore",
  component: "CapitalGainsCalculatorSingapore",
  title: "Singapore Capital Gains Tax Calculator - Property & Investment Gains | AfterTaxPay.net",
  description: "Use AfterTaxPay.net's Singapore Capital Gains Tax Calculator to estimate taxes on property gains and investment income. Calculate Singapore capital gains taxation.",
  keywords: "Singapore capital gains tax calculator, property gains Singapore, investment tax Singapore, Singapore property tax, capital gains tax Singapore"
},
{
  path: "/CapitalGainsCalculatorMexico",
  component: "CapitalGainsCalculatorMexico",
  title: "Mexico Capital Gains Tax Calculator - Real Estate & Investment Gains | AfterTaxPay.net",
  description: "Use AfterTaxPay.net's Mexico Capital Gains Tax Calculator to estimate taxes on real estate, investments, and asset sales. Calculate Mexican capital gains taxes.",
  keywords: "Mexico capital gains tax calculator, Mexican real estate tax, investment tax Mexico, asset sale tax, capital gains tax Mexico"
},
{
  path: "/CapitalGainsCalculatorBelgium",
  component: "CapitalGainsCalculatorBelgium",
  title: "Belgium Capital Gains Tax Calculator - Real Estate & Securities Tax | AfterTaxPay.net",
  description: "Use AfterTaxPay.net's Belgium Capital Gains Tax Calculator to estimate taxes on real estate, securities, and investment gains. Calculate Belgian capital gains taxes.",
  keywords: "Belgium capital gains tax calculator, Belgian real estate tax, securities tax Belgium, investment gains tax, capital gains tax Belgium"
},
{
  path: "/CapitalGainsCalculatorBrasil",
  component: "CapitalGainsCalculatorBrasil",
  title: "Brazil Capital Gains Tax Calculator - Stocks, Real Estate & Investments | AfterTaxPay.net",
  description: "Use AfterTaxPay.net's Brazil Capital Gains Tax Calculator to estimate taxes on stocks, real estate, and investments. Calculate Brazilian capital gains tax rates.",
  keywords: "Brazil capital gains tax calculator, Brazilian stock tax, real estate tax Brazil, investment tax Brazil, capital gains tax Brazil"
},
{
  path: "/CapitalGainsCalculatorEgypt",
  component: "CapitalGainsCalculatorEgypt",
  title: "Egypt Capital Gains Tax Calculator - Real Estate & Investment Gains | AfterTaxPay.net",
  description: "Use AfterTaxPay.net's Egypt Capital Gains Tax Calculator to estimate taxes on real estate, investments, and asset sales. Calculate Egyptian capital gains taxes.",
  keywords: "Egypt capital gains tax calculator, Egyptian real estate tax, investment tax Egypt, asset sale tax, capital gains tax Egypt"
},
{
  path: "/CapitalGainsCalculatorChina",
  component: "CapitalGainsCalculatorChina",
  title: "China Capital Gains Tax Calculator - Stocks, Property & Investments | AfterTaxPay.net",
  description: "Use AfterTaxPay.net's China Capital Gains Tax Calculator to estimate taxes on stocks, property, and investments. Calculate Chinese capital gains tax rates.",
  keywords: "China capital gains tax calculator, Chinese stock tax, property tax China, investment tax China, capital gains tax China"
},
{
  path: "/CapitalGainsCalculatorColombia",
  component: "CapitalGainsCalculatorColombia",
  title: "Colombia Capital Gains Tax Calculator - Real Estate & Investment Gains | AfterTaxPay.net",
  description: "Use AfterTaxPay.net's Colombia Capital Gains Tax Calculator to estimate taxes on real estate, investments, and asset sales. Calculate Colombian capital gains taxes.",
  keywords: "Colombia capital gains tax calculator, Colombian real estate tax, investment tax Colombia, asset sale tax, capital gains tax Colombia"
},
{
  path: "/CapitalGainsCalculatorHungary",
  component: "CapitalGainsCalculatorHungary",
  title: "Hungary Capital Gains Tax Calculator - Real Estate & Securities Tax | AfterTaxPay.net",
  description: "Use AfterTaxPay.net's Hungary Capital Gains Tax Calculator to estimate taxes on real estate, securities, and investment gains. Calculate Hungarian capital gains taxes.",
  keywords: "Hungary capital gains tax calculator, Hungarian real estate tax, securities tax Hungary, investment gains tax, capital gains tax Hungary"
},
{
  path: "/CapitalGainsCalculatorHongKong",
  component: "CapitalGainsCalculatorHongKong",
  title: "Hong Kong Capital Gains Tax Calculator - Property & Investment Gains | AfterTaxPay.net",
  description: "Use AfterTaxPay.net's Hong Kong Capital Gains Tax Calculator to estimate taxes on property gains and investment income. Calculate Hong Kong capital gains taxation.",
  keywords: "Hong Kong capital gains tax calculator, property gains Hong Kong, investment tax HK, Hong Kong property tax, capital gains tax Hong Kong"
},
{
  path: "/CapitalGainsCalculatorIndonesia",
  component: "CapitalGainsCalculatorIndonesia",
  title: "Indonesia Capital Gains Tax Calculator - Property & Investment Gains | AfterTaxPay.net",
  description: "Use AfterTaxPay.net's Indonesia Capital Gains Tax Calculator to estimate taxes on property, investments, and asset sales. Calculate Indonesian capital gains taxes.",
  keywords: "Indonesia capital gains tax calculator, Indonesian property tax, investment tax Indonesia, asset sale tax, capital gains tax Indonesia"
},
{
  path: "/CapitalGainsCalculatorMalaysia",
  component: "CapitalGainsCalculatorMalaysia",
  title: "Malaysia Capital Gains Tax Calculator - Real Property Gains Tax & Stocks | AfterTaxPay.net",
  description: "Use AfterTaxPay.net's Malaysia Capital Gains Tax Calculator to estimate RPGT on property and taxes on stocks. Calculate Malaysian capital gains taxes.",
  keywords: "Malaysia capital gains tax calculator, RPGT calculator, Malaysian property tax, stock tax Malaysia, capital gains tax Malaysia"
},
{
  path: "/CapitalGainsCalculatorPhilippines",
  component: "CapitalGainsCalculatorPhilippines",
  title: "Philippines Capital Gains Tax Calculator - Real Estate & Stock Gains | AfterTaxPay.net",
  description: "Use AfterTaxPay.net's Philippines Capital Gains Tax Calculator to estimate taxes on real estate, stocks, and investments. Calculate Philippine capital gains taxes.",
  keywords: "Philippines capital gains tax calculator, Philippine real estate tax, stock tax Philippines, investment tax Philippines, capital gains tax Philippines"
},


  // TaxRefundCalculator
{
  path: "/TaxRefundCalculatorUSA",
  component: "TaxRefundCalculatorUSA",
  title: "US Tax Refund Calculator - Estimate Your IRS Tax Refund | AfterTaxPay.net",
  description: "Use AfterTaxPay.net's US Tax Refund Calculator to estimate your IRS tax refund amount. Calculate federal and state tax refunds with credits and deductions.",
  keywords: "US tax refund calculator, IRS refund calculator, federal tax refund, state tax refund, tax refund estimator USA"
},
{
  path: "/TaxRefundCalculatorUK",
  component: "TaxRefundCalculatorUK",
  title: "UK Tax Refund Calculator - Estimate Your HMRC Tax Refund | AfterTaxPay.net",
  description: "Use AfterTaxPay.net's UK Tax Refund Calculator to estimate your HMRC tax refund amount. Calculate income tax refunds with allowances and tax reliefs.",
  keywords: "UK tax refund calculator, HMRC refund calculator, income tax refund UK, tax rebate calculator, UK tax refund estimator"
},
{
  path: "/TaxRefundCalculatorCanada",
  component: "TaxRefundCalculatorCanada",
  title: "Canada Tax Refund Calculator - Estimate Your CRA Tax Refund | AfterTaxPay.net",
  description: "Use AfterTaxPay.net's Canada Tax Refund Calculator to estimate your CRA tax refund amount. Calculate federal and provincial tax refunds with credits.",
  keywords: "Canada tax refund calculator, CRA refund calculator, Canadian tax refund, income tax refund Canada, tax refund estimator Canada"
},
{
  path: "/TaxRefundCalculatorAustralia",
  component: "TaxRefundCalculatorAustralia",
  title: "Australia Tax Refund Calculator - Estimate Your ATO Tax Refund | AfterTaxPay.net",
  description: "Use AfterTaxPay.net's Australia Tax Refund Calculator to estimate your ATO tax refund amount. Calculate your tax refund with deductions and offsets.",
  keywords: "Australia tax refund calculator, ATO refund calculator, Australian tax refund, tax rebate Australia, tax refund estimator Australia"
},
{
  path: "/TaxRefundCalculatorGermany",
  component: "TaxRefundCalculatorGermany",
  title: "Germany Tax Refund Calculator - Estimate Your Tax Refund (Steuererstattung) | AfterTaxPay.net",
  description: "Use AfterTaxPay.net's Germany Tax Refund Calculator to estimate your German tax refund amount. Calculate Steuererstattung with deductions and allowances.",
  keywords: "Germany tax refund calculator, German tax refund, Steuererstattung calculator, income tax refund Germany, tax refund estimator Germany"
},
{
  path: "/TaxRefundCalculatorSwitzerland",
  component: "TaxRefundCalculatorSwitzerland",
  title: "Switzerland Tax Refund Calculator - Estimate Your Tax Refund | AfterTaxPay.net",
  description: "Use AfterTaxPay.net's Switzerland Tax Refund Calculator to estimate your Swiss tax refund amount. Calculate federal and cantonal tax refunds.",
  keywords: "Switzerland tax refund calculator, Swiss tax refund, cantonal tax refund, income tax refund Switzerland, tax refund estimator Switzerland"
},
{
  path: "/TaxRefundCalculatorNorway",
  component: "TaxRefundCalculatorNorway",
  title: "Norway Tax Refund Calculator - Estimate Your Tax Refund (Skatteetaten) | AfterTaxPay.net",
  description: "Use AfterTaxPay.net's Norway Tax Refund Calculator to estimate your Norwegian tax refund amount. Calculate Skatteetaten refund with deductions.",
  keywords: "Norway tax refund calculator, Norwegian tax refund, Skatteetaten refund calculator, income tax refund Norway, tax refund estimator Norway"
},
{
  path: "/TaxRefundCalculatorNetherlands",
  component: "TaxRefundCalculatorNetherlands",
  title: "Netherlands Tax Refund Calculator - Estimate Your Tax Refund (Belastingdienst) | AfterTaxPay.net",
  description: "Use AfterTaxPay.net's Netherlands Tax Refund Calculator to estimate your Dutch tax refund amount. Calculate Belastingdienst refund with deductions.",
  keywords: "Netherlands tax refund calculator, Dutch tax refund, Belastingdienst refund calculator, income tax refund Netherlands, tax refund estimator Netherlands"
},
{
  path: "/TaxRefundCalculatorNewZealand",
  component: "TaxRefundCalculatorNewZealand",
  title: "New Zealand Tax Refund Calculator - Estimate Your IRD Tax Refund | AfterTaxPay.net",
  description: "Use AfterTaxPay.net's New Zealand Tax Refund Calculator to estimate your IRD tax refund amount. Calculate your NZ tax refund with deductions.",
  keywords: "New Zealand tax refund calculator, NZ tax refund, IRD refund calculator, income tax refund New Zealand, tax refund estimator NZ"
},
{
  path: "/TaxRefundCalculatorSweden",
  component: "TaxRefundCalculatorSweden",
  title: "Sweden Tax Refund Calculator - Estimate Your Tax Refund (Skatteverket) | AfterTaxPay.net",
  description: "Use AfterTaxPay.net's Sweden Tax Refund Calculator to estimate your Swedish tax refund amount. Calculate Skatteverket refund with deductions.",
  keywords: "Sweden tax refund calculator, Swedish tax refund, Skatteverket refund calculator, income tax refund Sweden, tax refund estimator Sweden"
},
{
  path: "/TaxRefundCalculatorFrance",
  component: "TaxRefundCalculatorFrance",
  title: "France Tax Refund Calculator - Estimate Your Tax Refund (Impôts) | AfterTaxPay.net",
  description: "Use AfterTaxPay.net's France Tax Refund Calculator to estimate your French tax refund amount. Calculate impôts refund with deductions and credits.",
  keywords: "France tax refund calculator, French tax refund, impôts refund calculator, income tax refund France, tax refund estimator France"
},
{
  path: "/TaxRefundCalculatorItaly",
  component: "TaxRefundCalculatorItaly",
  title: "Italy Tax Refund Calculator - Estimate Your Tax Refund (Agenzia delle Entrate) | AfterTaxPay.net",
  description: "Use AfterTaxPay.net's Italy Tax Refund Calculator to estimate your Italian tax refund amount. Calculate Agenzia delle Entrate refund with deductions.",
  keywords: "Italy tax refund calculator, Italian tax refund, Agenzia delle Entrate refund, income tax refund Italy, tax refund estimator Italy"
},
{
  path: "/TaxRefundCalculatorSpain",
  component: "TaxRefundCalculatorSpain",
  title: "Spain Tax Refund Calculator - Estimate Your Tax Refund (Agencia Tributaria) | AfterTaxPay.net",
  description: "Use AfterTaxPay.net's Spain Tax Refund Calculator to estimate your Spanish tax refund amount. Calculate Agencia Tributaria refund with deductions.",
  keywords: "Spain tax refund calculator, Spanish tax refund, Agencia Tributaria refund, income tax refund Spain, tax refund estimator Spain"
},
{
  path: "/TaxRefundCalculatorIndia",
  component: "TaxRefundCalculatorIndia",
  title: "India Tax Refund Calculator - Estimate Your Income Tax Refund | AfterTaxPay.net",
  description: "Use AfterTaxPay.net's India Tax Refund Calculator to estimate your Indian tax refund amount. Calculate income tax refund with deductions and exemptions.",
  keywords: "India tax refund calculator, Indian tax refund, income tax refund India, tax rebate India, tax refund estimator India"
},
{
  path: "/TaxRefundCalculatorJapan",
  component: "TaxRefundCalculatorJapan",
  title: "Japan Tax Refund Calculator - Estimate Your Tax Refund (Kakutei Shinkoku) | AfterTaxPay.net",
  description: "Use AfterTaxPay.net's Japan Tax Refund Calculator to estimate your Japanese tax refund amount. Calculate Kakutei Shinkoku refund with deductions.",
  keywords: "Japan tax refund calculator, Japanese tax refund, Kakutei Shinkoku refund, income tax refund Japan, tax refund estimator Japan"
},
{
  path: "/TaxRefundCalculatorDenmark",
  component: "TaxRefundCalculatorDenmark",
  title: "Denmark Tax Refund Calculator - Estimate Your Tax Refund (Skat) | AfterTaxPay.net",
  description: "Use AfterTaxPay.net's Denmark Tax Refund Calculator to estimate your Danish tax refund amount. Calculate Skat refund with deductions and allowances.",
  keywords: "Denmark tax refund calculator, Danish tax refund, Skat refund calculator, income tax refund Denmark, tax refund estimator Denmark"
},
{
  path: "/TaxRefundCalculatorFinland",
  component: "TaxRefundCalculatorFinland",
  title: "Finland Tax Refund Calculator - Estimate Your Tax Refund (Verotoimisto) | AfterTaxPay.net",
  description: "Use AfterTaxPay.net's Finland Tax Refund Calculator to estimate your Finnish tax refund amount. Calculate Verotoimisto refund with deductions.",
  keywords: "Finland tax refund calculator, Finnish tax refund, Verotoimisto refund, income tax refund Finland, tax refund estimator Finland"
},
{
  path: "/TaxRefundCalculatorAustria",
  component: "TaxRefundCalculatorAustria",
  title: "Austria Tax Refund Calculator - Estimate Your Tax Refund (Finanzamt) | AfterTaxPay.net",
  description: "Use AfterTaxPay.net's Austria Tax Refund Calculator to estimate your Austrian tax refund amount. Calculate Finanzamt refund with deductions.",
  keywords: "Austria tax refund calculator, Austrian tax refund, Finanzamt refund, income tax refund Austria, tax refund estimator Austria"
},
{
  path: "/TaxRefundCalculatorSingapore",
  component: "TaxRefundCalculatorSingapore",
  title: "Singapore Tax Refund Calculator - Estimate Your IRAS Tax Refund | AfterTaxPay.net",
  description: "Use AfterTaxPay.net's Singapore Tax Refund Calculator to estimate your IRAS tax refund amount. Calculate Singapore tax refund with reliefs.",
  keywords: "Singapore tax refund calculator, Singapore tax refund, IRAS refund calculator, income tax refund Singapore, tax refund estimator Singapore"
},
{
  path: "/TaxRefundCalculatorMexico",
  component: "TaxRefundCalculatorMexico",
  title: "Mexico Tax Refund Calculator - Estimate Your SAT Tax Refund | AfterTaxPay.net",
  description: "Use AfterTaxPay.net's Mexico Tax Refund Calculator to estimate your SAT tax refund amount. Calculate Mexican tax refund with deductions.",
  keywords: "Mexico tax refund calculator, Mexican tax refund, SAT refund calculator, income tax refund Mexico, tax refund estimator Mexico"
},
{
  path: "/TaxRefundCalculatorBelgium",
  component: "TaxRefundCalculatorBelgium",
  title: "Belgium Tax Refund Calculator - Estimate Your Tax Refund (FOD Financiën) | AfterTaxPay.net",
  description: "Use AfterTaxPay.net's Belgium Tax Refund Calculator to estimate your Belgian tax refund amount. Calculate FOD Financiën refund with deductions.",
  keywords: "Belgium tax refund calculator, Belgian tax refund, FOD Financiën refund, income tax refund Belgium, tax refund estimator Belgium"
},
{
  path: "/TaxRefundCalculatorBrasil",
  component: "TaxRefundCalculatorBrasil",
  title: "Brazil Tax Refund Calculator - Estimate Your Receita Federal Tax Refund | AfterTaxPay.net",
  description: "Use AfterTaxPay.net's Brazil Tax Refund Calculator to estimate your Receita Federal tax refund amount. Calculate Brazilian tax refund with deductions.",
  keywords: "Brazil tax refund calculator, Brazilian tax refund, Receita Federal refund, income tax refund Brazil, tax refund estimator Brazil"
},
{
  path: "/TaxRefundCalculatorEgypt",
  component: "TaxRefundCalculatorEgypt",
  title: "Egypt Tax Refund Calculator - Estimate Your Tax Refund (ETA) | AfterTaxPay.net",
  description: "Use AfterTaxPay.net's Egypt Tax Refund Calculator to estimate your Egyptian tax refund amount. Calculate Egyptian Tax Authority refund with deductions.",
  keywords: "Egypt tax refund calculator, Egyptian tax refund, ETA refund calculator, income tax refund Egypt, tax refund estimator Egypt"
},
{
  path: "/TaxRefundCalculatorChina",
  component: "TaxRefundCalculatorChina",
  title: "China Tax Refund Calculator - Estimate Your Tax Refund (SAT) | AfterTaxPay.net",
  description: "Use AfterTaxPay.net's China Tax Refund Calculator to estimate your Chinese tax refund amount. Calculate State Taxation Administration refund.",
  keywords: "China tax refund calculator, Chinese tax refund, SAT refund calculator, income tax refund China, tax refund estimator China"
},
{
  path: "/TaxRefundCalculatorColombia",
  component: "TaxRefundCalculatorColombia",
  title: "Colombia Tax Refund Calculator - Estimate Your DIAN Tax Refund | AfterTaxPay.net",
  description: "Use AfterTaxPay.net's Colombia Tax Refund Calculator to estimate your DIAN tax refund amount. Calculate Colombian tax refund with deductions.",
  keywords: "Colombia tax refund calculator, Colombian tax refund, DIAN refund calculator, income tax refund Colombia, tax refund estimator Colombia"
},
{
  path: "/TaxRefundCalculatorHungary",
  component: "TaxRefundCalculatorHungary",
  title: "Hungary Tax Refund Calculator - Estimate Your NAV Tax Refund | AfterTaxPay.net",
  description: "Use AfterTaxPay.net's Hungary Tax Refund Calculator to estimate your NAV tax refund amount. Calculate Hungarian tax refund with deductions.",
  keywords: "Hungary tax refund calculator, Hungarian tax refund, NAV refund calculator, income tax refund Hungary, tax refund estimator Hungary"
},
{
  path: "/TaxRefundCalculatorHongKong",
  component: "TaxRefundCalculatorHongKong",
  title: "Hong Kong Tax Refund Calculator - Estimate Your IRD Tax Refund | AfterTaxPay.net",
  description: "Use AfterTaxPay.net's Hong Kong Tax Refund Calculator to estimate your IRD tax refund amount. Calculate Hong Kong tax refund with allowances.",
  keywords: "Hong Kong tax refund calculator, HK tax refund, IRD Hong Kong refund, income tax refund Hong Kong, tax refund estimator Hong Kong"
},
{
  path: "/TaxRefundCalculatorIndonesia",
  component: "TaxRefundCalculatorIndonesia",
  title: "Indonesia Tax Refund Calculator - Estimate Your DJP Tax Refund | AfterTaxPay.net",
  description: "Use AfterTaxPay.net's Indonesia Tax Refund Calculator to estimate your DJP tax refund amount. Calculate Indonesian tax refund with deductions.",
  keywords: "Indonesia tax refund calculator, Indonesian tax refund, DJP refund calculator, income tax refund Indonesia, tax refund estimator Indonesia"
},
{
  path: "/TaxRefundCalculatorMalaysia",
  component: "TaxRefundCalculatorMalaysia",
  title: "Malaysia Tax Refund Calculator - Estimate Your LHDN Tax Refund | AfterTaxPay.net",
  description: "Use AfterTaxPay.net's Malaysia Tax Refund Calculator to estimate your LHDN tax refund amount. Calculate Malaysian tax refund with reliefs.",
  keywords: "Malaysia tax refund calculator, Malaysian tax refund, LHDN refund calculator, income tax refund Malaysia, tax refund estimator Malaysia"
},
{
  path: "/TaxRefundCalculatorPhilippines",
  component: "TaxRefundCalculatorPhilippines",
  title: "Philippines Tax Refund Calculator - Estimate Your BIR Tax Refund | AfterTaxPay.net",
  description: "Use AfterTaxPay.net's Philippines Tax Refund Calculator to estimate your BIR tax refund amount. Calculate Philippine tax refund with deductions.",
  keywords: "Philippines tax refund calculator, Philippine tax refund, BIR refund calculator, income tax refund Philippines, tax refund estimator Philippines"
},


  // PensionTaxCalculator
  {
  path: "/PensionTaxCalculatorUSA",
  component: "PensionTaxCalculatorUSA",
  title: "US Pension Tax Calculator - 401k, IRA & Pension Withdrawal Taxes | AfterTaxPay.net",
  description: "Use AfterTaxPay.net's US Pension Tax Calculator to estimate taxes on 401k, IRA, and pension withdrawals. Calculate tax on retirement plan distributions in the US.",
  keywords: "US pension tax calculator, 401k withdrawal tax, IRA distribution tax, pension withdrawal tax USA, retirement plan tax calculator"
},
{
  path: "/PensionTaxCalculatorCanada",
  component: "PensionTaxCalculatorCanada",
  title: "Canada Pension Tax Calculator - RRSP, CPP & Pension Withdrawal Taxes | AfterTaxPay.net",
  description: "Use AfterTaxPay.net's Canada Pension Tax Calculator to estimate taxes on RRSP, CPP, and pension withdrawals. Calculate tax on retirement income in Canada.",
  keywords: "Canada pension tax calculator, RRSP withdrawal tax, CPP tax calculator, pension withdrawal tax Canada, Canadian retirement tax"
},
{
  path: "/PensionTaxCalculatorAustralia",
  component: "PensionTaxCalculatorAustralia",
  title: "Australia Pension Tax Calculator - Superannuation & Age Pension Taxes | AfterTaxPay.net",
  description: "Use AfterTaxPay.net's Australia Pension Tax Calculator to estimate taxes on superannuation and Age Pension withdrawals. Calculate Australian pension taxes.",
  keywords: "Australia pension tax calculator, superannuation tax, Age Pension tax, Australian pension withdrawal tax, retirement income tax Australia"
},
{
  path: "/PensionTaxCalculatorUK",
  component: "PensionTaxCalculatorUK",
  title: "UK Pension Tax Calculator - State Pension & Private Pension Taxes | AfterTaxPay.net",
  description: "Use AfterTaxPay.net's UK Pension Tax Calculator to estimate taxes on State Pension and private pension withdrawals. Calculate UK pension tax rates.",
  keywords: "UK pension tax calculator, State Pension tax, private pension tax UK, pension withdrawal tax UK, UK retirement tax"
},
{
  path: "/PensionTaxCalculatorGerman",
  component: "PensionTaxCalculatorGerman",
  title: "Germany Pension Tax Calculator - State Pension & Private Pension Taxes | AfterTaxPay.net",
  description: "Use AfterTaxPay.net's Germany Pension Tax Calculator to estimate taxes on state pension and private pension withdrawals. Calculate German pension taxes.",
  keywords: "Germany pension tax calculator, German state pension tax, private pension tax Germany, pension withdrawal tax Germany, German retirement tax"
},
{
  path: "/PensionTaxCalculatorSwitzerland",
  component: "PensionTaxCalculatorSwitzerland",
  title: "Switzerland Pension Tax Calculator - Pillar 2 & 3 Pension Withdrawal Taxes | AfterTaxPay.net",
  description: "Use AfterTaxPay.net's Switzerland Pension Tax Calculator to estimate taxes on Pillar 2 and Pillar 3 pension withdrawals. Calculate Swiss pension taxes.",
  keywords: "Switzerland pension tax calculator, Pillar 2 pension tax, Pillar 3 pension tax, Swiss pension withdrawal tax, Switzerland retirement tax"
},
{
  path: "/PensionTaxCalculatorNorway",
  component: "PensionTaxCalculatorNorway",
  title: "Norway Pension Tax Calculator - Folketrygd & Private Pension Taxes | AfterTaxPay.net",
  description: "Use AfterTaxPay.net's Norway Pension Tax Calculator to estimate taxes on Folketrygd and private pension withdrawals. Calculate Norwegian pension taxes.",
  keywords: "Norway pension tax calculator, Folketrygd tax, private pension tax Norway, Norwegian pension withdrawal tax, Norway retirement tax"
},
{
  path: "/PensionTaxCalculatorNL",
  component: "PensionTaxCalculatorNL",
  title: "Netherlands Pension Tax Calculator - AOW & Private Pension Taxes | AfterTaxPay.net",
  description: "Use AfterTaxPay.net's Netherlands Pension Tax Calculator to estimate taxes on AOW and private pension withdrawals. Calculate Dutch pension taxes.",
  keywords: "Netherlands pension tax calculator, AOW tax, private pension tax Netherlands, Dutch pension withdrawal tax, Netherlands retirement tax"
},
{
  path: "/PensionTaxCalculatorNZ",
  component: "PensionTaxCalculatorNZ",
  title: "New Zealand Pension Tax Calculator - NZ Super & KiwiSaver Taxes | AfterTaxPay.net",
  description: "Use AfterTaxPay.net's New Zealand Pension Tax Calculator to estimate taxes on NZ Super and KiwiSaver withdrawals. Calculate NZ pension taxes.",
  keywords: "New Zealand pension tax calculator, NZ Super tax, KiwiSaver tax, NZ pension withdrawal tax, New Zealand retirement tax"
},
{
  path: "/PensionTaxCalculatorSweden",
  component: "PensionTaxCalculatorSweden",
  title: "Sweden Pension Tax Calculator - State Pension & Private Pension Taxes | AfterTaxPay.net",
  description: "Use AfterTaxPay.net's Sweden Pension Tax Calculator to estimate taxes on state pension and private pension withdrawals. Calculate Swedish pension taxes.",
  keywords: "Sweden pension tax calculator, Swedish state pension tax, private pension tax Sweden, pension withdrawal tax Sweden, Sweden retirement tax"
},
{
  path: "/PensionTaxCalculatorFrance",
  component: "PensionTaxCalculatorFrance",
  title: "France Pension Tax Calculator - State & Complementary Pension Taxes | AfterTaxPay.net",
  description: "Use AfterTaxPay.net's France Pension Tax Calculator to estimate taxes on state and complementary pension withdrawals. Calculate French pension taxes.",
  keywords: "France pension tax calculator, French state pension tax, complementary pension tax, pension withdrawal tax France, France retirement tax"
},
{
  path: "/PensionTaxCalculatorItaly",
  component: "PensionTaxCalculatorItaly",
  title: "Italy Pension Tax Calculator - INPS & Private Pension Taxes | AfterTaxPay.net",
  description: "Use AfterTaxPay.net's Italy Pension Tax Calculator to estimate taxes on INPS and private pension withdrawals. Calculate Italian pension taxes.",
  keywords: "Italy pension tax calculator, INPS pension tax, private pension tax Italy, pension withdrawal tax Italy, Italy retirement tax"
},
{
  path: "/PensionTaxCalculatorSpain",
  component: "PensionTaxCalculatorSpain",
  title: "Spain Pension Tax Calculator - State & Private Pension Taxes | AfterTaxPay.net",
  description: "Use AfterTaxPay.net's Spain Pension Tax Calculator to estimate taxes on state and private pension withdrawals. Calculate Spanish pension taxes.",
  keywords: "Spain pension tax calculator, Spanish state pension tax, private pension tax Spain, pension withdrawal tax Spain, Spain retirement tax"
},
{
  path: "/PensionTaxCalculatorIndia",
  component: "PensionTaxCalculatorIndia",
  title: "India Pension Tax Calculator - NPS, EPF & Pension Income Taxes | AfterTaxPay.net",
  description: "Use AfterTaxPay.net's India Pension Tax Calculator to estimate taxes on NPS, EPF, and pension income. Calculate Indian pension withdrawal taxes.",
  keywords: "India pension tax calculator, NPS tax, EPF withdrawal tax, pension income tax India, Indian retirement tax"
},
{
  path: "/PensionTaxCalculatorJapan",
  component: "PensionTaxCalculatorJapan",
  title: "Japan Pension Tax Calculator - National Pension & Private Pension Taxes | AfterTaxPay.net",
  description: "Use AfterTaxPay.net's Japan Pension Tax Calculator to estimate taxes on national pension and private pension withdrawals. Calculate Japanese pension taxes.",
  keywords: "Japan pension tax calculator, Japanese national pension tax, private pension tax Japan, pension withdrawal tax Japan, Japan retirement tax"
},
{
  path: "/PensionTaxCalculatorDenmark",
  component: "PensionTaxCalculatorDenmark",
  title: "Denmark Pension Tax Calculator - State & Private Pension Taxes | AfterTaxPay.net",
  description: "Use AfterTaxPay.net's Denmark Pension Tax Calculator to estimate taxes on state and private pension withdrawals. Calculate Danish pension taxes.",
  keywords: "Denmark pension tax calculator, Danish state pension tax, private pension tax Denmark, pension withdrawal tax Denmark, Denmark retirement tax"
},
{
  path: "/PensionTaxCalculatorFinland",
  component: "PensionTaxCalculatorFinland",
  title: "Finland Pension Tax Calculator - National & Private Pension Taxes | AfterTaxPay.net",
  description: "Use AfterTaxPay.net's Finland Pension Tax Calculator to estimate taxes on national and private pension withdrawals. Calculate Finnish pension taxes.",
  keywords: "Finland pension tax calculator, Finnish national pension tax, private pension tax Finland, pension withdrawal tax Finland, Finland retirement tax"
},
{
  path: "/PensionTaxCalculatorAustria",
  component: "PensionTaxCalculatorAustria",
  title: "Austria Pension Tax Calculator - State & Private Pension Taxes | AfterTaxPay.net",
  description: "Use AfterTaxPay.net's Austria Pension Tax Calculator to estimate taxes on state and private pension withdrawals. Calculate Austrian pension taxes.",
  keywords: "Austria pension tax calculator, Austrian state pension tax, private pension tax Austria, pension withdrawal tax Austria, Austria retirement tax"
},
{
  path: "/PensionTaxCalculatorSingapore",
  component: "PensionTaxCalculatorSingapore",
  title: "Singapore Pension Tax Calculator - CPF & Private Pension Taxes | AfterTaxPay.net",
  description: "Use AfterTaxPay.net's Singapore Pension Tax Calculator to estimate taxes on CPF and private pension withdrawals. Calculate Singapore pension taxes.",
  keywords: "Singapore pension tax calculator, CPF withdrawal tax, private pension tax Singapore, pension withdrawal tax Singapore, Singapore retirement tax"
},
{
  path: "/PensionTaxCalculatorMexico",
  component: "PensionTaxCalculatorMexico",
  title: "Mexico Pension Tax Calculator - AFORE & Private Pension Taxes | AfterTaxPay.net",
  description: "Use AfterTaxPay.net's Mexico Pension Tax Calculator to estimate taxes on AFORE and private pension withdrawals. Calculate Mexican pension taxes.",
  keywords: "Mexico pension tax calculator, AFORE tax, private pension tax Mexico, pension withdrawal tax Mexico, Mexico retirement tax"
},
{
  path: "/PensionTaxCalculatorBelgium",
  component: "PensionTaxCalculatorBelgium",
  title: "Belgium Pension Tax Calculator - State & Private Pension Taxes | AfterTaxPay.net",
  description: "Use AfterTaxPay.net's Belgium Pension Tax Calculator to estimate taxes on state and private pension withdrawals. Calculate Belgian pension taxes.",
  keywords: "Belgium pension tax calculator, Belgian state pension tax, private pension tax Belgium, pension withdrawal tax Belgium, Belgium retirement tax"
},
{
  path: "/PensionTaxCalculatorBrasil",
  component: "PensionTaxCalculatorBrasil",
  title: "Brazil Pension Tax Calculator - INSS & Private Pension Taxes | AfterTaxPay.net",
  description: "Use AfterTaxPay.net's Brazil Pension Tax Calculator to estimate taxes on INSS and private pension withdrawals. Calculate Brazilian pension taxes.",
  keywords: "Brazil pension tax calculator, INSS tax, private pension tax Brazil, pension withdrawal tax Brazil, Brazil retirement tax"
},
{
  path: "/PensionTaxCalculatorEgypt",
  component: "PensionTaxCalculatorEgypt",
  title: "Egypt Pension Tax Calculator - Social Insurance & Private Pension Taxes | AfterTaxPay.net",
  description: "Use AfterTaxPay.net's Egypt Pension Tax Calculator to estimate taxes on social insurance and private pension withdrawals. Calculate Egyptian pension taxes.",
  keywords: "Egypt pension tax calculator, Egyptian social insurance tax, private pension tax Egypt, pension withdrawal tax Egypt, Egypt retirement tax"
},
{
  path: "/PensionTaxCalculatorChina",
  component: "PensionTaxCalculatorChina",
  title: "China Pension Tax Calculator - State & Private Pension Taxes | AfterTaxPay.net",
  description: "Use AfterTaxPay.net's China Pension Tax Calculator to estimate taxes on state and private pension withdrawals. Calculate Chinese pension taxes.",
  keywords: "China pension tax calculator, Chinese state pension tax, private pension tax China, pension withdrawal tax China, China retirement tax"
},
{
  path: "/PensionTaxCalculatorColombia",
  component: "PensionTaxCalculatorColombia",
  title: "Colombia Pension Tax Calculator - State & Private Pension Taxes | AfterTaxPay.net",
  description: "Use AfterTaxPay.net's Colombia Pension Tax Calculator to estimate taxes on state and private pension withdrawals. Calculate Colombian pension taxes.",
  keywords: "Colombia pension tax calculator, Colombian state pension tax, private pension tax Colombia, pension withdrawal tax Colombia, Colombia retirement tax"
},
{
  path: "/PensionTaxCalculatorHungary",
  component: "PensionTaxCalculatorHungary",
  title: "Hungary Pension Tax Calculator - State & Private Pension Taxes | AfterTaxPay.net",
  description: "Use AfterTaxPay.net's Hungary Pension Tax Calculator to estimate taxes on state and private pension withdrawals. Calculate Hungarian pension taxes.",
  keywords: "Hungary pension tax calculator, Hungarian state pension tax, private pension tax Hungary, pension withdrawal tax Hungary, Hungary retirement tax"
},
{
  path: "/PensionTaxCalculatorHongKong",
  component: "PensionTaxCalculatorHongKong",
  title: "Hong Kong Pension Tax Calculator - MPF & Private Pension Taxes | AfterTaxPay.net",
  description: "Use AfterTaxPay.net's Hong Kong Pension Tax Calculator to estimate taxes on MPF and private pension withdrawals. Calculate Hong Kong pension taxes.",
  keywords: "Hong Kong pension tax calculator, MPF tax, private pension tax Hong Kong, pension withdrawal tax Hong Kong, Hong Kong retirement tax"
},
{
  path: "/PensionTaxCalculatorIndonesia",
  component: "PensionTaxCalculatorIndonesia",
  title: "Indonesia Pension Tax Calculator - BPJS & Private Pension Taxes | AfterTaxPay.net",
  description: "Use AfterTaxPay.net's Indonesia Pension Tax Calculator to estimate taxes on BPJS and private pension withdrawals. Calculate Indonesian pension taxes.",
  keywords: "Indonesia pension tax calculator, BPJS tax, private pension tax Indonesia, pension withdrawal tax Indonesia, Indonesia retirement tax"
},
{
  path: "/PensionTaxCalculatorMalaysia",
  component: "PensionTaxCalculatorMalaysia",
  title: "Malaysia Pension Tax Calculator - EPF & Private Pension Taxes | AfterTaxPay.net",
  description: "Use AfterTaxPay.net's Malaysia Pension Tax Calculator to estimate taxes on EPF and private pension withdrawals. Calculate Malaysian pension taxes.",
  keywords: "Malaysia pension tax calculator, EPF tax, private pension tax Malaysia, pension withdrawal tax Malaysia, Malaysia retirement tax"
},
{
  path: "/PensionTaxCalculatorPhilippines",
  component: "PensionTaxCalculatorPhilippines",
  title: "Philippines Pension Tax Calculator - SSS, GSIS & Private Pension Taxes | AfterTaxPay.net",
  description: "Use AfterTaxPay.net's Philippines Pension Tax Calculator to estimate taxes on SSS, GSIS, and private pension withdrawals. Calculate Philippine pension taxes.",
  keywords: "Philippines pension tax calculator, SSS tax, GSIS tax, private pension tax Philippines, Philippines retirement tax"
},


  // EstatePlanningCalculator
  {
  path: "/EstatePlanningCalculatorUSA",
  component: "EstatePlanningCalculatorUSA",
  title: "US Estate Planning Calculator - Estate Tax & Inheritance Planning | AfterTaxPay.net",
  description: "Use AfterTaxPay.net's US Estate Planning Calculator to estimate estate taxes, plan inheritance, and calculate federal and state estate settlement costs.",
  keywords: "US estate planning calculator, estate tax calculator USA, inheritance planning, estate settlement costs, federal estate tax planning"
},
{
  path: "/EstatePlanningCalculatorCanada",
  component: "EstatePlanningCalculatorCanada",
  title: "Canada Estate Planning Calculator - Probate Fees & Estate Settlement | AfterTaxPay.net",
  description: "Use AfterTaxPay.net's Canada Estate Planning Calculator to estimate probate fees, plan estate distribution, and calculate estate administration costs in Canada.",
  keywords: "Canada estate planning calculator, probate fees calculator, estate administration Canada, inheritance planning Canada, Canadian estate tax"
},
{
  path: "/EstatePlanningCalculatorAustralia",
  component: "EstatePlanningCalculatorAustralia",
  title: "Australia Estate Planning Calculator - Estate Distribution & Tax Planning | AfterTaxPay.net",
  description: "Use AfterTaxPay.net's Australia Estate Planning Calculator to plan estate distribution, estimate capital gains tax, and calculate estate settlement costs.",
  keywords: "Australia estate planning calculator, estate distribution Australia, capital gains tax inheritance, estate settlement Australia, Australian inheritance planning"
},
{
  path: "/EstatePlanningCalculatorUK",
  component: "EstatePlanningCalculatorUK",
  title: "UK Estate Planning Calculator - IHT Planning & Estate Distribution | AfterTaxPay.net",
  description: "Use AfterTaxPay.net's UK Estate Planning Calculator to plan for Inheritance Tax (IHT), estimate estate taxes, and calculate estate distribution costs in the UK.",
  keywords: "UK estate planning calculator, IHT planning calculator, estate distribution UK, inheritance tax planning, UK estate settlement"
},
{
  path: "/EstatePlanningCalculatorGermany",
  component: "EstatePlanningCalculatorGermany",
  title: "Germany Estate Planning Calculator - Erbschaftsteuer & Estate Planning | AfterTaxPay.net",
  description: "Use AfterTaxPay.net's Germany Estate Planning Calculator to plan for Erbschaftsteuer, estimate inheritance taxes, and calculate estate distribution in Germany.",
  keywords: "Germany estate planning calculator, Erbschaftsteuer planning, German inheritance planning, estate distribution Germany, German estate tax planning"
},
{
  path: "/EstatePlanningCalculatorSwitzerland",
  component: "EstatePlanningCalculatorSwitzerland",
  title: "Switzerland Estate Planning Calculator - Cantonal Inheritance & Estate Planning | AfterTaxPay.net",
  description: "Use AfterTaxPay.net's Switzerland Estate Planning Calculator to plan for cantonal inheritance taxes, estimate estate costs, and calculate succession planning.",
  keywords: "Switzerland estate planning calculator, cantonal inheritance planning, Swiss estate distribution, succession planning Switzerland, Swiss estate tax"
},
{
  path: "/EstatePlanningCalculatorNorway",
  component: "EstatePlanningCalculatorNorway",
  title: "Norway Estate Planning Calculator - Arveavgift & Estate Distribution | AfterTaxPay.net",
  description: "Use AfterTaxPay.net's Norway Estate Planning Calculator to plan for arveavgift, estimate inheritance taxes, and calculate estate distribution costs in Norway.",
  keywords: "Norway estate planning calculator, arveavgift planning, Norwegian inheritance planning, estate distribution Norway, Norwegian estate tax"
},
{
  path: "/EstatePlanningCalculatorNetherlands",
  component: "EstatePlanningCalculatorNetherlands",
  title: "Netherlands Estate Planning Calculator - Successiebelasting & Estate Planning | AfterTaxPay.net",
  description: "Use AfterTaxPay.net's Netherlands Estate Planning Calculator to plan for successiebelasting, estimate inheritance taxes, and calculate estate distribution.",
  keywords: "Netherlands estate planning calculator, successiebelasting planning, Dutch inheritance planning, estate distribution Netherlands, Dutch estate tax"
},
{
  path: "/EstatePlanningCalculatorNewZealand",
  component: "EstatePlanningCalculatorNewZealand",
  title: "New Zealand Estate Planning Calculator - Estate Administration & Distribution | AfterTaxPay.net",
  description: "Use AfterTaxPay.net's New Zealand Estate Planning Calculator to plan estate administration, estimate distribution costs, and calculate estate settlement.",
  keywords: "New Zealand estate planning calculator, estate administration NZ, estate distribution New Zealand, NZ inheritance planning, estate settlement New Zealand"
},
{
  path: "/EstatePlanningCalculatorSweden",
  component: "EstatePlanningCalculatorSweden",
  title: "Sweden Estate Planning Calculator - Arvsskatt & Estate Distribution | AfterTaxPay.net",
  description: "Use AfterTaxPay.net's Sweden Estate Planning Calculator to plan for arvsskatt, estimate inheritance taxes, and calculate estate distribution in Sweden.",
  keywords: "Sweden estate planning calculator, arvsskatt planning, Swedish inheritance planning, estate distribution Sweden, Swedish estate tax"
},
{
  path: "/EstatePlanningCalculatorFrance",
  component: "EstatePlanningCalculatorFrance",
  title: "France Estate Planning Calculator - Droits de Succession & Estate Planning | AfterTaxPay.net",
  description: "Use AfterTaxPay.net's France Estate Planning Calculator to plan for droits de succession, estimate inheritance taxes, and calculate estate distribution.",
  keywords: "France estate planning calculator, droits de succession planning, French inheritance planning, estate distribution France, French estate tax"
},
{
  path: "/EstatePlanningCalculatorItaly",
  component: "EstatePlanningCalculatorItaly",
  title: "Italy Estate Planning Calculator - Tasse di Successione & Estate Planning | AfterTaxPay.net",
  description: "Use AfterTaxPay.net's Italy Estate Planning Calculator to plan for tasse di successione, estimate inheritance taxes, and calculate estate distribution.",
  keywords: "Italy estate planning calculator, tasse di successione planning, Italian inheritance planning, estate distribution Italy, Italian estate tax"
},
{
  path: "/EstatePlanningCalculatorSpain",
  component: "EstatePlanningCalculatorSpain",
  title: "Spain Estate Planning Calculator - Impuesto de Sucesiones & Estate Planning | AfterTaxPay.net",
  description: "Use AfterTaxPay.net's Spain Estate Planning Calculator to plan for impuesto de sucesiones, estimate inheritance taxes, and calculate estate distribution.",
  keywords: "Spain estate planning calculator, impuesto de sucesiones planning, Spanish inheritance planning, estate distribution Spain, Spanish estate tax"
},
{
  path: "/EstatePlanningCalculatorIndia",
  component: "EstatePlanningCalculatorIndia",
  title: "India Estate Planning Calculator - Estate Distribution & Inheritance Planning | AfterTaxPay.net",
  description: "Use AfterTaxPay.net's India Estate Planning Calculator to plan estate distribution, estimate inheritance costs, and calculate estate settlement in India.",
  keywords: "India estate planning calculator, estate distribution India, inheritance planning India, Indian estate settlement, estate administration India"
},
{
  path: "/EstatePlanningCalculatorJapan",
  component: "EstatePlanningCalculatorJapan",
  title: "Japan Estate Planning Calculator - Sōzokuzei & Estate Distribution | AfterTaxPay.net",
  description: "Use AfterTaxPay.net's Japan Estate Planning Calculator to plan for sōzokuzei, estimate inheritance taxes, and calculate estate distribution in Japan.",
  keywords: "Japan estate planning calculator, sōzokuzei planning, Japanese inheritance planning, estate distribution Japan, Japanese estate tax"
},
{
  path: "/EstatePlanningCalculatorDenmark",
  component: "EstatePlanningCalculatorDenmark",
  title: "Denmark Estate Planning Calculator - Arveafgift & Estate Distribution | AfterTaxPay.net",
  description: "Use AfterTaxPay.net's Denmark Estate Planning Calculator to plan for arveafgift, estimate inheritance taxes, and calculate estate distribution in Denmark.",
  keywords: "Denmark estate planning calculator, arveafgift planning, Danish inheritance planning, estate distribution Denmark, Danish estate tax"
},
{
  path: "/EstatePlanningCalculatorFinland",
  component: "EstatePlanningCalculatorFinland",
  title: "Finland Estate Planning Calculator - Perintövero & Estate Distribution | AfterTaxPay.net",
  description: "Use AfterTaxPay.net's Finland Estate Planning Calculator to plan for perintövero, estimate inheritance taxes, and calculate estate distribution in Finland.",
  keywords: "Finland estate planning calculator, perintövero planning, Finnish inheritance planning, estate distribution Finland, Finnish estate tax"
},
{
  path: "/EstatePlanningCalculatorAustria",
  component: "EstatePlanningCalculatorAustria",
  title: "Austria Estate Planning Calculator - Erbschaftssteuer & Estate Planning | AfterTaxPay.net",
  description: "Use AfterTaxPay.net's Austria Estate Planning Calculator to plan for Erbschaftssteuer, estimate inheritance taxes, and calculate estate distribution.",
  keywords: "Austria estate planning calculator, Erbschaftssteuer planning, Austrian inheritance planning, estate distribution Austria, Austrian estate tax"
},
{
  path: "/EstatePlanningCalculatorSingapore",
  component: "EstatePlanningCalculatorSingapore",
  title: "Singapore Estate Planning Calculator - Estate Administration & Distribution | AfterTaxPay.net",
  description: "Use AfterTaxPay.net's Singapore Estate Planning Calculator to plan estate administration, estimate distribution costs, and calculate estate settlement.",
  keywords: "Singapore estate planning calculator, estate administration Singapore, estate distribution Singapore, Singapore inheritance planning, estate settlement Singapore"
},
{
  path: "/EstatePlanningCalculatorMexico",
  component: "EstatePlanningCalculatorMexico",
  title: "Mexico Estate Planning Calculator - Impuesto de Sucesiones & Estate Planning | AfterTaxPay.net",
  description: "Use AfterTaxPay.net's Mexico Estate Planning Calculator to plan for impuesto de sucesiones, estimate inheritance taxes, and calculate estate distribution.",
  keywords: "Mexico estate planning calculator, impuesto de sucesiones planning, Mexican inheritance planning, estate distribution Mexico, Mexican estate tax"
},
{
  path: "/EstatePlanningCalculatorBelgium",
  component: "EstatePlanningCalculatorBelgium",
  title: "Belgium Estate Planning Calculator - Succesierechten & Estate Planning | AfterTaxPay.net",
  description: "Use AfterTaxPay.net's Belgium Estate Planning Calculator to plan for succesierechten, estimate inheritance taxes, and calculate estate distribution.",
  keywords: "Belgium estate planning calculator, succesierechten planning, Belgian inheritance planning, estate distribution Belgium, Belgian estate tax"
},
{
  path: "/EstatePlanningCalculatorBrazil",
  component: "EstatePlanningCalculatorBrazil",
  title: "Brazil Estate Planning Calculator - ITCMD & Estate Distribution | AfterTaxPay.net",
  description: "Use AfterTaxPay.net's Brazil Estate Planning Calculator to plan for ITCMD, estimate inheritance taxes, and calculate estate distribution in Brazil.",
  keywords: "Brazil estate planning calculator, ITCMD planning, Brazilian inheritance planning, estate distribution Brazil, Brazilian estate tax"
},
{
  path: "/EstatePlanningCalculatorEgypt",
  component: "EstatePlanningCalculatorEgypt",
  title: "Egypt Estate Planning Calculator - Inheritance & Estate Distribution | AfterTaxPay.net",
  description: "Use AfterTaxPay.net's Egypt Estate Planning Calculator to plan inheritance distribution, estimate estate costs, and calculate settlement fees in Egypt.",
  keywords: "Egypt estate planning calculator, Egyptian inheritance planning, estate distribution Egypt, estate settlement Egypt, Egyptian estate administration"
},
{
  path: "/EstatePlanningCalculatorChina",
  component: "EstatePlanningCalculatorChina",
  title: "China Estate Planning Calculator - Estate Distribution & Inheritance Planning | AfterTaxPay.net",
  description: "Use AfterTaxPay.net's China Estate Planning Calculator to plan estate distribution, estimate inheritance costs, and calculate estate settlement in China.",
  keywords: "China estate planning calculator, estate distribution China, inheritance planning China, Chinese estate settlement, estate administration China"
},
{
  path: "/EstatePlanningCalculatorColombia",
  component: "EstatePlanningCalculatorColombia",
  title: "Colombia Estate Planning Calculator - Impuesto de Sucesiones & Estate Planning | AfterTaxPay.net",
  description: "Use AfterTaxPay.net's Colombia Estate Planning Calculator to plan for impuesto de sucesiones, estimate inheritance taxes, and calculate estate distribution.",
  keywords: "Colombia estate planning calculator, impuesto de sucesiones planning, Colombian inheritance planning, estate distribution Colombia, Colombian estate tax"
},
{
  path: "/EstatePlanningCalculatorHungary",
  component: "EstatePlanningCalculatorHungary",
  title: "Hungary Estate Planning Calculator - Öröklési Adó & Estate Distribution | AfterTaxPay.net",
  description: "Use AfterTaxPay.net's Hungary Estate Planning Calculator to plan for öröklési adó, estimate inheritance taxes, and calculate estate distribution in Hungary.",
  keywords: "Hungary estate planning calculator, öröklési adó planning, Hungarian inheritance planning, estate distribution Hungary, Hungarian estate tax"
},
{
  path: "/EstatePlanningCalculatorHongKong",
  component: "EstatePlanningCalculatorHongKong",
  title: "Hong Kong Estate Planning Calculator - Estate Duty & Distribution Planning | AfterTaxPay.net",
  description: "Use AfterTaxPay.net's Hong Kong Estate Planning Calculator to plan for estate duty, estimate inheritance costs, and calculate estate distribution in Hong Kong.",
  keywords: "Hong Kong estate planning calculator, estate duty planning Hong Kong, HK inheritance planning, estate distribution Hong Kong, Hong Kong estate administration"
},
{
  path: "/EstatePlanningCalculatorIndonesia",
  component: "EstatePlanningCalculatorIndonesia",
  title: "Indonesia Estate Planning Calculator - Waris & Estate Distribution | AfterTaxPay.net",
  description: "Use AfterTaxPay.net's Indonesia Estate Planning Calculator to plan for waris taxes, estimate inheritance costs, and calculate estate distribution in Indonesia.",
  keywords: "Indonesia estate planning calculator, waris planning Indonesia, Indonesian inheritance planning, estate distribution Indonesia, Indonesian estate tax"
},
{
  path: "/EstatePlanningCalculatorMalaysia",
  component: "EstatePlanningCalculatorMalaysia",
  title: "Malaysia Estate Planning Calculator - Estate Administration & Distribution | AfterTaxPay.net",
  description: "Use AfterTaxPay.net's Malaysia Estate Planning Calculator to plan estate administration, estimate distribution costs, and calculate estate settlement.",
  keywords: "Malaysia estate planning calculator, estate administration Malaysia, estate distribution Malaysia, Malaysian inheritance planning, estate settlement Malaysia"
},
{
  path: "/EstatePlanningCalculatorPhilippines",
  component: "EstatePlanningCalculatorPhilippines",
  title: "Philippines Estate Planning Calculator - Estate Tax & Distribution Planning | AfterTaxPay.net",
  description: "Use AfterTaxPay.net's Philippines Estate Planning Calculator to plan estate tax, estimate inheritance costs, and calculate estate distribution in the Philippines.",
  keywords: "Philippines estate planning calculator, estate tax planning Philippines, Philippine inheritance planning, estate distribution Philippines, Philippine estate settlement"
},

 
// ProbateCostCalculator
{
  path: "/ProbateCostCalculatorUSA",
  component: "ProbateCostCalculatorUSA",
  title: "US Probate Cost Calculator - Estimate Probate Fees & Court Costs | AfterTaxPay.net",
  description: "Use AfterTaxPay.net's US Probate Cost Calculator to estimate probate fees, court costs, attorney fees, and estate administration expenses across states.",
  keywords: "US probate cost calculator, probate fees USA, estate administration costs, probate court fees, executor fees calculator"
},
{
  path: "/ProbateCostCalculatorCanada",
  component: "ProbateCostCalculatorCanada",
  title: "Canada Probate Cost Calculator - Estimate Probate Fees & Estate Taxes | AfterTaxPay.net",
  description: "Use AfterTaxPay.net's Canada Probate Cost Calculator to estimate probate fees, estate administration taxes, and court costs across provinces and territories.",
  keywords: "Canada probate cost calculator, probate fees Canada, estate administration taxes, probate court costs, Canadian probate fees"
},
{
  path: "/ProbateCostCalculatorAustralia",
  component: "ProbateCostCalculatorAustralia",
  title: "Australia Probate Cost Calculator - Estimate Probate Fees & Legal Costs | AfterTaxPay.net",
  description: "Use AfterTaxPay.net's Australia Probate Cost Calculator to estimate probate fees, legal costs, court fees, and estate administration expenses across states.",
  keywords: "Australia probate cost calculator, probate fees Australia, legal costs probate, court fees Australia, estate administration costs"
},
{
  path: "/ProbateCostCalculatorUK",
  component: "ProbateCostCalculatorUK",
  title: "UK Probate Cost Calculator - Estimate Probate Fees & Inheritance Tax | AfterTaxPay.net",
  description: "Use AfterTaxPay.net's UK Probate Cost Calculator to estimate probate fees, court costs, and inheritance tax administration costs across England, Scotland, Wales, and NI.",
  keywords: "UK probate cost calculator, probate fees UK, inheritance tax costs, probate court fees, UK estate administration"
},
{
  path: "/ProbateCostCalculatorGermany",
  component: "ProbateCostCalculatorGermany",
  title: "Germany Probate Cost Calculator - Estimate Nachlassverfahren Costs | AfterTaxPay.net",
  description: "Use AfterTaxPay.net's Germany Probate Cost Calculator to estimate Nachlassverfahren costs, court fees, and estate administration expenses across German states.",
  keywords: "Germany probate cost calculator, Nachlassverfahren costs, German court fees, estate administration Germany, probate costs Germany"
},
{
  path: "/ProbateCostCalculatorSwitzerland",
  component: "ProbateCostCalculatorSwitzerland",
  title: "Switzerland Probate Cost Calculator - Estimate Estate Settlement Costs | AfterTaxPay.net",
  description: "Use AfterTaxPay.net's Switzerland Probate Cost Calculator to estimate estate settlement costs, court fees, and administration expenses across Swiss cantons.",
  keywords: "Switzerland probate cost calculator, estate settlement costs Switzerland, Swiss court fees, administration expenses, Swiss probate costs"
},
{
  path: "/ProbateCostCalculatorNorway",
  component: "ProbateCostCalculatorNorway",
  title: "Norway Probate Cost Calculator - Estimate Skifte Costs & Court Fees | AfterTaxPay.net",
  description: "Use AfterTaxPay.net's Norway Probate Cost Calculator to estimate skifte costs, court fees, and estate administration expenses across Norwegian municipalities.",
  keywords: "Norway probate cost calculator, skifte costs Norway, Norwegian court fees, estate administration Norway, probate costs Norway"
},
{
  path: "/ProbateCostCalculatorNetherlands",
  component: "ProbateCostCalculatorNetherlands",
  title: "Netherlands Probate Cost Calculator - Estimate Versterfbelasting Costs | AfterTaxPay.net",
  description: "Use AfterTaxPay.net's Netherlands Probate Cost Calculator to estimate versterfbelasting costs, court fees, and estate administration expenses.",
  keywords: "Netherlands probate cost calculator, versterfbelasting costs, Dutch court fees, estate administration Netherlands, probate costs Netherlands"
},
{
  path: "/ProbateCostCalculatorNewZealand",
  component: "ProbateCostCalculatorNewZealand",
  title: "New Zealand Probate Cost Calculator - Estimate Probate Fees & Legal Costs | AfterTaxPay.net",
  description: "Use AfterTaxPay.net's New Zealand Probate Cost Calculator to estimate probate fees, legal costs, court fees, and administration expenses across NZ regions.",
  keywords: "New Zealand probate cost calculator, probate fees NZ, legal costs New Zealand, court fees NZ, estate administration costs"
},
{
  path: "/ProbateCostCalculatorSweden",
  component: "ProbateCostCalculatorSweden",
  title: "Sweden Probate Cost Calculator - Estimate Bouppteckning Costs | AfterTaxPay.net",
  description: "Use AfterTaxPay.net's Sweden Probate Cost Calculator to estimate bouppteckning costs, court fees, and estate administration expenses across Swedish municipalities.",
  keywords: "Sweden probate cost calculator, bouppteckning costs, Swedish court fees, estate administration Sweden, probate costs Sweden"
},
{
  path: "/ProbateCostCalculatorFrance",
  component: "ProbateCostCalculatorFrance",
  title: "France Probate Cost Calculator - Estimate Succession Costs & Notary Fees | AfterTaxPay.net",
  description: "Use AfterTaxPay.net's France Probate Cost Calculator to estimate succession costs, notary fees, court expenses, and estate administration across departments.",
  keywords: "France probate cost calculator, succession costs France, notary fees, French court expenses, estate administration France"
},
{
  path: "/ProbateCostCalculatorItaly",
  component: "ProbateCostCalculatorItaly",
  title: "Italy Probate Cost Calculator - Estimate Successione Costs & Notary Fees | AfterTaxPay.net",
  description: "Use AfterTaxPay.net's Italy Probate Cost Calculator to estimate successione costs, notary fees, court expenses, and estate administration across regions.",
  keywords: "Italy probate cost calculator, successione costs, Italian notary fees, court expenses Italy, estate administration Italy"
},
{
  path: "/ProbateCostCalculatorSpain",
  component: "ProbateCostCalculatorSpain",
  title: "Spain Probate Cost Calculator - Estimate Sucesión Costs & Notary Fees | AfterTaxPay.net",
  description: "Use AfterTaxPay.net's Spain Probate Cost Calculator to estimate sucesión costs, notary fees, court expenses, and estate administration across autonomous communities.",
  keywords: "Spain probate cost calculator, sucesión costs, Spanish notary fees, court expenses Spain, estate administration Spain"
},
{
  path: "/ProbateCostCalculatorIndia",
  component: "ProbateCostCalculatorIndia",
  title: "India Probate Cost Calculator - Estimate Court Fees & Legal Costs | AfterTaxPay.net",
  description: "Use AfterTaxPay.net's India Probate Cost Calculator to estimate court fees, legal costs, stamp duty, and estate administration expenses across states.",
  keywords: "India probate cost calculator, court fees India, legal costs probate, stamp duty India, estate administration costs"
},
{
  path: "/ProbateCostCalculatorJapan",
  component: "ProbateCostCalculatorJapan",
  title: "Japan Probate Cost Calculator - Estimate Sōzoku Costs & Court Fees | AfterTaxPay.net",
  description: "Use AfterTaxPay.net's Japan Probate Cost Calculator to estimate sōzoku costs, court fees, and estate administration expenses across Japanese prefectures.",
  keywords: "Japan probate cost calculator, sōzoku costs Japan, Japanese court fees, estate administration Japan, probate costs Japan"
},
{
  path: "/ProbateCostCalculatorDenmark",
  component: "ProbateCostCalculatorDenmark",
  title: "Denmark Probate Cost Calculator - Estimate Skifte Costs & Court Fees | AfterTaxPay.net",
  description: "Use AfterTaxPay.net's Denmark Probate Cost Calculator to estimate skifte costs, court fees, and estate administration expenses across Danish municipalities.",
  keywords: "Denmark probate cost calculator, skifte costs Denmark, Danish court fees, estate administration Denmark, probate costs Denmark"
},
{
  path: "/ProbateCostCalculatorFinland",
  component: "ProbateCostCalculatorFinland",
  title: "Finland Probate Cost Calculator - Estimate Perukirja Costs & Court Fees | AfterTaxPay.net",
  description: "Use AfterTaxPay.net's Finland Probate Cost Calculator to estimate perukirja costs, court fees, and estate administration expenses across Finnish municipalities.",
  keywords: "Finland probate cost calculator, perukirja costs, Finnish court fees, estate administration Finland, probate costs Finland"
},
{
  path: "/ProbateCostCalculatorAustria",
  component: "ProbateCostCalculatorAustria",
  title: "Austria Probate Cost Calculator - Estimate Verlassenschaftsabhandlung Costs | AfterTaxPay.net",
  description: "Use AfterTaxPay.net's Austria Probate Cost Calculator to estimate Verlassenschaftsabhandlung costs, court fees, and estate administration expenses across states.",
  keywords: "Austria probate cost calculator, Verlassenschaftsabhandlung costs, Austrian court fees, estate administration Austria, probate costs Austria"
},
{
  path: "/ProbateCostCalculatorSingapore",
  component: "ProbateCostCalculatorSingapore",
  title: "Singapore Probate Cost Calculator - Estimate Grant of Probate Costs | AfterTaxPay.net",
  description: "Use AfterTaxPay.net's Singapore Probate Cost Calculator to estimate Grant of Probate costs, court fees, legal expenses, and administration fees.",
  keywords: "Singapore probate cost calculator, Grant of Probate costs, Singapore court fees, legal expenses, estate administration Singapore"
},
{
  path: "/ProbateCostCalculatorMexico",
  component: "ProbateCostCalculatorMexico",
  title: "Mexico Probate Cost Calculator - Estimate Juicio Successorio Costs | AfterTaxPay.net",
  description: "Use AfterTaxPay.net's Mexico Probate Cost Calculator to estimate juicio successorio costs, notary fees, court expenses, and estate administration across states.",
  keywords: "Mexico probate cost calculator, juicio successorio costs, Mexican notary fees, court expenses Mexico, estate administration Mexico"
},
{
  path: "/ProbateCostCalculatorBelgium",
  component: "ProbateCostCalculatorBelgium",
  title: "Belgium Probate Cost Calculator - Estimate Versterfbelasting Costs | AfterTaxPay.net",
  description: "Use AfterTaxPay.net's Belgium Probate Cost Calculator to estimate versterfbelasting costs, notary fees, court expenses, and estate administration across regions.",
  keywords: "Belgium probate cost calculator, versterfbelasting costs, Belgian notary fees, court expenses Belgium, estate administration Belgium"
},
{
  path: "/ProbateCostCalculatorBrasil",
  component: "ProbateCostCalculatorBrasil",
  title: "Brazil Probate Cost Calculator - Estimate Inventário Costs & Court Fees | AfterTaxPay.net",
  description: "Use AfterTaxPay.net's Brazil Probate Cost Calculator to estimate inventário costs, court fees, notary expenses, and estate administration across states.",
  keywords: "Brazil probate cost calculator, inventário costs, Brazilian court fees, notary expenses Brazil, estate administration Brazil"
},
{
  path: "/ProbateCostCalculatorEgypt",
  component: "ProbateCostCalculatorEgypt",
  title: "Egypt Probate Cost Calculator - Estimate Estate Settlement Costs | AfterTaxPay.net",
  description: "Use AfterTaxPay.net's Egypt Probate Cost Calculator to estimate estate settlement costs, court fees, legal expenses, and administration fees across governorates.",
  keywords: "Egypt probate cost calculator, estate settlement costs Egypt, court fees Egypt, legal expenses, estate administration Egypt"
},
{
  path: "/ProbateCostCalculatorChina",
  component: "ProbateCostCalculatorChina",
  title: "China Probate Cost Calculator - Estimate Estate Administration Costs | AfterTaxPay.net",
  description: "Use AfterTaxPay.net's China Probate Cost Calculator to estimate estate administration costs, court fees, legal expenses, and notary fees across provinces.",
  keywords: "China probate cost calculator, estate administration costs China, court fees China, legal expenses, Chinese notary fees"
},
{
  path: "/ProbateCostCalculatorColombia",
  component: "ProbateCostCalculatorColombia",
  title: "Colombia Probate Cost Calculator - Estimate Sucesión Costs & Notary Fees | AfterTaxPay.net",
  description: "Use AfterTaxPay.net's Colombia Probate Cost Calculator to estimate sucesión costs, notary fees, court expenses, and estate administration across departments.",
  keywords: "Colombia probate cost calculator, sucesión costs Colombia, Colombian notary fees, court expenses, estate administration Colombia"
},
{
  path: "/ProbateCostCalculatorHungary",
  component: "ProbateCostCalculatorHungary",
  title: "Hungary Probate Cost Calculator - Estimate Hozzájárulási Costs & Court Fees | AfterTaxPay.net",
  description: "Use AfterTaxPay.net's Hungary Probate Cost Calculator to estimate hozzájárulási costs, court fees, and estate administration expenses across municipalities.",
  keywords: "Hungary probate cost calculator, hozzájárulási costs, Hungarian court fees, estate administration Hungary, probate costs Hungary"
},
{
  path: "/ProbateCostCalculatorHongKong",
  component: "ProbateCostCalculatorHongKong",
  title: "Hong Kong Probate Cost Calculator - Estimate Grant of Probate Costs | AfterTaxPay.net",
  description: "Use AfterTaxPay.net's Hong Kong Probate Cost Calculator to estimate Grant of Probate costs, court fees, legal expenses, and administration fees in Hong Kong.",
  keywords: "Hong Kong probate cost calculator, Grant of Probate costs HK, Hong Kong court fees, legal expenses HK, estate administration Hong Kong"
},
{
  path: "/ProbateCostCalculatorIndonesia",
  component: "ProbateCostCalculatorIndonesia",
  title: "Indonesia Probate Cost Calculator - Estimate Waris Costs & Court Fees | AfterTaxPay.net",
  description: "Use AfterTaxPay.net's Indonesia Probate Cost Calculator to estimate waris costs, court fees, notary expenses, and estate administration across provinces.",
  keywords: "Indonesia probate cost calculator, waris costs Indonesia, Indonesian court fees, notary expenses, estate administration Indonesia"
},
{
  path: "/ProbateCostCalculatorMalaysia",
  component: "ProbateCostCalculatorMalaysia",
  title: "Malaysia Probate Cost Calculator - Estimate Grant of Probate Costs | AfterTaxPay.net",
  description: "Use AfterTaxPay.net's Malaysia Probate Cost Calculator to estimate Grant of Probate costs, court fees, legal expenses, and administration fees across states.",
  keywords: "Malaysia probate cost calculator, Grant of Probate costs Malaysia, Malaysian court fees, legal expenses, estate administration Malaysia"
},
{
  path: "/ProbateCostCalculatorPhilippines",
  component: "ProbateCostCalculatorPhilippines",
  title: "Philippines Probate Cost Calculator - Estimate Estate Settlement Costs | AfterTaxPay.net",
  description: "Use AfterTaxPay.net's Philippines Probate Cost Calculator to estimate estate settlement costs, court fees, legal expenses, and administration fees across regions.",
  keywords: "Philippines probate cost calculator, estate settlement costs Philippines, court fees Philippines, legal expenses, estate administration Philippines"
},


  // Time & Salary Calculators
  {
  path: "/TimeCardCalculator",
  component: "TimeCardCalculator",
  title: "Time Card Calculator - Calculate Work Hours & Timesheets | AfterTaxPay.net",
  description: "Use AfterTaxPay.net's Time Card Calculator to calculate work hours, track timesheets, and compute total hours worked with break deductions.",
  keywords: "time card calculator, work hours calculator, timesheet calculator, hours worked calculator, time tracking calculator"
},
{
  path: "/HoursToDecimalConverter",
  component: "HoursToDecimalConverter",
  title: "Hours to Decimal Converter - Convert Hours & Minutes to Decimal | AfterTaxPay.net",
  description: "Use AfterTaxPay.net's Hours to Decimal Converter to easily convert hours and minutes to decimal format for payroll, billing, and time calculations.",
  keywords: "hours to decimal converter, time to decimal converter, hours minutes to decimal, payroll time converter, decimal time calculator"
},
{
  path: "/BillingHoursCalculator",
  component: "BillingHoursCalculator",
  title: "Billing Hours Calculator - Calculate Billable Hours & Invoices | AfterTaxPay.net",
  description: "Use AfterTaxPay.net's Billing Hours Calculator to calculate billable hours, create invoices, and track client billing for freelancers and businesses.",
  keywords: "billing hours calculator, billable hours calculator, invoice hours calculator, client billing calculator, freelance billing calculator"
},
{
  path: "/TimesheetConverter",
  component: "TimesheetConverter",
  title: "Timesheet Converter - Convert Timesheets Between Formats | AfterTaxPay.net",
  description: "Use AfterTaxPay.net's Timesheet Converter to convert timesheets between different formats, calculate totals, and prepare payroll data efficiently.",
  keywords: "timesheet converter, time sheet converter, payroll converter, work hours converter, time format converter"
},
{
  path: "/SalaryToHourlyCalculator",
  component: "SalaryToHourlyCalculator",
  title: "Salary to Hourly Calculator - Convert Annual Salary to Hourly Rate | AfterTaxPay.net",
  description: "Use AfterTaxPay.net's Salary to Hourly Calculator to convert annual salary to hourly wage rate based on work hours per week and weeks per year.",
  keywords: "salary to hourly calculator, annual salary to hourly, salary converter, hourly wage calculator, salary conversion calculator"
},
{
  path: "/HourlyToSalaryCalculator",
  component: "HourlyToSalaryCalculator",
  title: "Hourly to Salary Calculator - Convert Hourly Wage to Annual Salary | AfterTaxPay.net",
  description: "Use AfterTaxPay.net's Hourly to Salary Calculator to convert hourly wage to annual salary based on work hours per week and weeks per year.",
  keywords: "hourly to salary calculator, hourly wage to salary, wage to salary converter, annual salary calculator, hourly rate to salary"
},
{
  path: "/TimeOffAccrualCalculator",
  component: "TimeOffAccrualCalculator",
  title: "Time Off Accrual Calculator - Calculate Vacation & Sick Leave Accrual | AfterTaxPay.net",
  description: "Use AfterTaxPay.net's Time Off Accrual Calculator to calculate vacation, sick leave, and PTO accrual based on company policy and employment duration.",
  keywords: "time off accrual calculator, vacation accrual calculator, sick leave calculator, PTO calculator, leave accrual calculator"
},
{
  path: "/OvertimeCalculator",
  component: "OvertimeCalculator",
  title: "Overtime Calculator - Calculate Overtime Pay & Hours | AfterTaxPay.net",
  description: "Use AfterTaxPay.net's Overtime Calculator to calculate overtime pay, hours, and rates for regular, double, and triple overtime scenarios.",
  keywords: "overtime calculator, overtime pay calculator, overtime hours calculator, time and a half calculator, double time calculator"
},
{
  path: "/BreakTimeCalculator",
  component: "BreakTimeCalculator",
  title: "Break Time Calculator - Calculate Work Breaks & Lunch Time | AfterTaxPay.net",
  description: "Use AfterTaxPay.net's Break Time Calculator to calculate break durations, lunch breaks, and total work hours with break deductions.",
  keywords: "break time calculator, lunch break calculator, work breaks calculator, break duration calculator, time management calculator"
},
];

// NOTE: You have 300+ routes total. For brevity, I've shown patterns for each category.
// You need to add ALL your remaining routes following the same pattern.
// Each route should have: path, component, title, description, keywords

// Helper function to get route by path
export const getRouteByPath = (path) => {
  return calculatorRoutes.find(route => route.path === path);
};

// Helper function to get all paths
export const getAllPaths = () => {
  return calculatorRoutes.map(route => route.path);
};